// English UI strings. Keys are namespaced by area. Keep this file and is.js in sync.
export default {
    auth: {
        pleaseWait: 'Please wait ...',
        backToSignIn: 'Back to the sign-in page',
        email: 'E-mail',
        password: 'Password',
        continueWithGoogle: 'Continue with Google',
        authSuccess: 'Authentication successful, redirecting ....',
        externalProviderError: 'Error from external provider.  Please try again later!',
        externalLoginInfoError: 'Error loading external login information.  Please try again later!',
        lockedOut: 'Your account seems to be locked out!',
        signupsClosed: 'There is no Webcy account for that Google account, and new sign-ups are closed. Ask an account owner to invite you.',
        orUseLocal: '... or use a local account:',
        rememberMe: 'Remember me on this device',
        signIn: 'Sign in',
        noAccountSignup: "Don't have an account? Signup now",
        forgotPassword: 'Forgot your password?',
        twoFaPrompt: 'This account is protected with a two-factor authentication.  Please enter your verification code below:',
        rememberDevice: 'Remember this device',
        rememberDeviceHint: 'The next time you log-in on this device, you will not need to use two factor authentication',
        useRecoveryCode: "Don't have your mobile device?  Authenticate with recovery code",
        or: 'or',
        differentAccount: 'Sign in with a different account',
        enterRecoveryCode: 'Enter one of your unused recovery codes to authenticate.',
        back: 'Back',
        authenticating: 'Authenticating, please wait ...',
        resetSent: 'If an account matching the specified e-mail address was found, an e-mail will be sent to that address with password reset instructions.',
        emailPlaceholder: 'Type the e-mail address you used for your Webcy account',
        continue: 'Continue',
        passwordResetSuccess: 'Your password has been reset successfully!',
        newPassword: 'New password',
        retypeNewPassword: 'Re-type new password',
        updatePassword: 'Update password',
        emailVerified: 'Your e-mail has been successfully verified!  Feel free to close this window.',
        signupSuccess: 'Sign-up successful, redirecting ....',
        orContinueEmail: '... or continue with your e-mail:',
        choosePassword: 'Choose a password',
        repeatPassword: 'Repeat the password',
        yourNameOptional: 'Your name (optional)',
        signUp: 'Sign up',
        codeSentTo: "We've e-mailed a confirmation code to {0}. Enter it below to confirm your e-mail address.",
        confirm: 'Confirm',
        resendCode: "Didn't get it? Resend code",
        changeDetails: 'Change your details',
        finalizeStep: 'One more step to finalize your account!',
        accountName: 'Account name',
        accountNameHint: 'This could be your company name for example',
        accountDescOptional: 'Account description (optional)',
        keywordsLabel: 'Type a few keywords to describe your business (optional)',
        keywordsHint: 'Such as restaurant, sushi, burgers etc.',
        createAccount: 'Create account',
        completingSignup: 'Completing sign-up, please wait ...',
        invalidInvite: 'Invalid invitation link.  It might already have been used or it might have expired.',
        invitedToJoin: 'You have been invited to join {0}!',
        authenticatedAs: 'You are currently authenticated as {0}',
        continueAs: 'Continue as {user}',
        signOutAcceptNew: 'Sign out and accept invitation as a new user',
        acceptInvitation: 'Accept invitation'
    },
    common: {
        save: 'Save',
        cancel: 'Cancel',
        close: 'Close',
        ok: 'OK',
        yes: 'Yes',
        no: 'No',
        dismiss: 'Dismiss',
        retry: 'Retry',
        loading: 'Loading ...',
        delete: 'Delete',
        remove: 'Remove',
        add: 'Add',
        create: 'Create',
        update: 'Update',
        edit: 'Edit',
        view: 'View',
        name: 'Name',
        title: 'Title',
        description: 'Description',
        active: 'Active',
        search: 'Search',
        email: 'E-mail',
        password: 'Password',
        username: 'Username',
        confirmation: 'Confirmation',
        noEntriesFound: 'No entries found!'
    },
    publish: {
        publish: 'Publish',
        publishOptions: 'Publish options',
        publishNow: 'Publish now',
        schedulePublishEllipsis: 'Schedule publish ...',
        reschedulePublishEllipsis: 'Reschedule publish ...',
        cancelScheduled: 'Cancel scheduled publish',
        schedulePublish: 'Schedule publish',
        reschedulePublish: 'Reschedule publish',
        date: 'Date',
        time: 'Time',
        schedule: 'Schedule',
        publishesAt: 'Publishes {date}',
        published: 'Published',
        publishChanges: 'Publish changes',
        dateMustBeFuture: 'The publish date must be in the future.'
    },
    chat: {
        assistantName: 'Webcy Assistant',
        newChat: 'New chat',
        history: 'History',
        noPreviousChats: 'No previous chats',
        untitled: 'Untitled',
        emptyPrompt: 'Ask me to create or edit screens, playlists and assets in this account.',
        forExample: 'For example:',
        emptyExample: '"Create a 1920×1080 welcome screen with a dark background and centered text."',
        connectionLost: 'Connection lost — reconnecting…',
        editingThisScreen: 'Editing this screen',
        editingThisPlaylist: 'Editing this playlist',
        messagePlaceholder: 'Message the assistant…',
        send: 'Send',
        deleteConversationConfirm: 'Delete this conversation?',
        deleteConversationTitle: 'Delete conversation',
        menu: 'Menu',
        ready: 'Ready to help',
        working: 'Working on it…',
        reconnecting: 'Reconnecting…',
        viewHistory: 'View history',
        usedTools: 'Used {n} tool | Used {n} tools',
        usingTools: 'Using tools… ({n})',
        errCouldNotConnect: 'Could not connect to the assistant. Please try again.',
        errCouldNotStart: 'Could not start a conversation.',
        connectionInterrupted: 'The connection was interrupted. Reconnecting… you can resend your message in a moment.',
        somethingWentWrong: 'Something went wrong.',
        errorGeneric: 'Error'
    },
    nav: {
        overview: 'Overview',
        content: 'Content',
        playlists: 'Playlists',
        players: 'Players',
        schedules: 'Schedules',
        triggers: 'Triggers',
        products: 'Products',
        dataSources: 'Data sources',
        analytics: 'Analytics',
        brandKits: 'Brand kits',
        themes: 'Themes',
        recycleBin: 'Recycle bin',
        billing: 'Billing',
        team: 'Team',
        audit: 'Audit',
        administration: 'Administration'
    },
    layout: {
        myProfile: 'My profile ...',
        accountSettings: 'Account settings ...',
        switchTo: 'Switch to "{name}"',
        logout: 'Log out',
        yourAccounts: 'Your accounts'
    },
    profile: {
        title: 'My profile',
        loading: 'Loading profile ...',
        tabGeneral: 'General',
        tabPassword: 'Password',
        tab2fa: 'Two factor authentication',
        basicIntro: 'Here you can update your basic information.',
        userName: 'User name',
        email: 'E-mail address',
        emailNotVerified: 'Your e-mail address has not been verified yet. With an unverified e-mail address, you will not be able to request a new password and use Google authentication.',
        verifyNow: 'Verify now',
        emailVerified: 'Your e-mail address is verified.',
        fullName: 'Full name',
        saveChanges: 'Save changes',
        appearance: 'Appearance',
        darkMode: 'Dark mode',
        darkModeHint: 'Use a dark theme for the dashboard. Saved to your user, so it follows you across devices.',
        language: 'Language',
        languageHint: 'The language of the dashboard interface. Saved to your user, so it follows you across devices.',
        passwordIntro: 'Here you can update your password.',
        currentPassword: 'Current password',
        newPassword: 'New password',
        newPasswordRepeated: 'New password repeated',
        updatePassword: 'Update password',
        twoFaEnabled: 'Two-factor authentication is enabled for your account!',
        twoFaNotEnabled: 'Two-factor authentication is not enabled! You can greatly increase the security of your account by enabling Two-factor authentication.',
        enable2fa: 'Enable two-factor authentication',
        noCodesLeft: 'You have no recovery codes left.',
        noCodesLeftInfo: 'You must generate a new set of recovery codes before you can log in with a recovery code.',
        oneCodeLeft: 'You have 1 recovery code left.',
        oneCodeLeftInfo: 'You can generate a new set of recovery codes.',
        fewCodesLeft: 'You have {count} recovery codes left.',
        fewCodesLeftInfo: 'You should generate a new set of recovery codes now.',
        disable2fa: 'Disable 2FA',
        forgetBrowser: 'Forget this browser',
        generateCodes: 'Generate recovery codes',
        basicInfoSaved: 'Basic info saved!',
        passwordChanged: 'Password changed successfully!'
    },
    billing: {
        title: 'Billing',
        viewReceipt: 'View receipt',
        selectAccount: 'Select an account from the account selector to view its billing.',
        paymentMethod: 'Payment method:',
        expShort: 'exp {month}/{year}',
        noneOnFile: 'none on file',
        addCard: 'Add card',
        updateCard: 'Update card',
        changePlan: 'Change plan',
        detailsPanel: 'Billing details',
        detailsPanelHint: '(shown on your invoices)',
        billedToName: 'Billed to (name)',
        taxId: 'Kennitala / VAT number',
        address: 'Address',
        country: 'Country',
        billingEmail: 'Billing email',
        saveDetails: 'Save billing details',
        invoicesIntro: 'Invoices are generated monthly and charged automatically to the card on file.',
        noInvoices: 'No invoices yet.',
        colInvoiceNo: 'Invoice #',
        colPeriod: 'Period',
        colPlan: 'Plan',
        colPlayers: 'Players',
        colAmount: 'Amount',
        colStatus: 'Status',
        colPaidWith: 'Paid with',
        colCharged: 'Charged',
        chipPlanChange: 'plan change',
        chipProrated: 'prorated',
        inclCredit: 'incl. {amount} credit',
        downloadPdf: 'Download PDF',
        savedPaymentMethod: 'Payment method saved.',
        cardMgmtDisabled: 'Online card management is not enabled. Contact us to set up billing.',
        cardSetupFailed: 'Could not start card setup. Please try again.',
        detailsSaved: 'Billing details saved.',
        detailsSaveFailed: 'Could not save billing details.',
        pdfFailed: 'Could not download the invoice PDF.'
    },
    plan: {
        current: 'Current',
        currentPlan: 'Current plan',
        selectThisPlan: 'Select this plan',
        perPlayerMonth: '/ player / month',
        upToPlayers: 'Up to {count} player | Up to {count} players',
        unlimitedPlayers: 'Unlimited players',
        minPlayers: 'Billed for a minimum of {count} player | Billed for a minimum of {count} players',
        unlimitedStorage: 'Unlimited storage',
        storage: '{size} storage',
        overage: 'then {price}/MB over quota',
        hardLimit: 'hard limit (no overage)',
        featureAi: 'Webcy Assistant (AI)',
        featureBrandKits: 'Brand kits',
        featureProducts: 'Product integrations/Analytics',
        featureDataSources: 'Data sources',
        changeTitle: 'Change subscription plan',
        loadingPlans: 'Loading plans ...',
        noPlans: 'No plans are available right now.',
        addCardBeforeSelect: 'Add a payment method before selecting a plan.',
        addPaymentMethod: 'Add payment method',
        requiredTitle: 'Choose a subscription plan',
        requiredSubtitle: 'Select a plan for this account to continue. You can change it later.',
        noPlansContactSupport: 'No subscription plans are available right now. Please contact support.',
        addCardFirst: 'First, add a payment method. Your plan is billed monthly, so a card is required before you can choose a plan.',
        planChangedTo: 'Subscription plan changed to {name}.',
        paymentMethodSaved: 'Payment method saved.',
        upgradeTitle: 'Upgrade your plan',
        upgradeInstructions: 'Upgrade your subscription to unlock this. Contact your account administrator to change your plan.',
        upgradeDefaultMessage: "This isn't included in your plan."
    },
    invoicesAdmin: {
        runBilling: 'Run billing now',
        status: 'Status',
        statusAll: 'All',
        statusPending: 'Pending',
        statusPaid: 'Paid',
        statusFailed: 'Failed',
        account: 'Account',
        count: '{count} invoice(s)',
        billingComplete: 'Billing run complete.',
        colInvoiceNo: 'Invoice #',
        colAccount: 'Account',
        colPeriod: 'Period',
        colPlan: 'Plan',
        colPlayers: 'Players',
        colAmount: 'Amount',
        colStatus: 'Status',
        colAttempts: 'Attempts',
        colNextRetry: 'Next retry date',
        colCharged: 'Charged',
        chipPlanChange: 'plan change',
        chipProrated: 'prorated'
    },
    dashboard: {
        selectAccount: 'Please select an account from the account selector in the bottom left to see an overview of that account!',
        loading: 'Loading overview ...',
        qlDynamicContent: 'Dynamic content',
        qlAssets: 'Assets',
        qlPlaylists: 'Playlists',
        qlPlayers: 'Players',
        qlSchedules: 'Schedules',
        qlProducts: 'Products',
        subscriptionPlan: 'Subscription plan',
        nextBilling: 'Next billing',
        billing: 'Billing',
        noPaymentTitle: 'No payment method on file.',
        noPaymentText: 'Add a card so your monthly subscription invoice can be paid.',
        addPaymentMethod: 'Add payment method',
        playerHealth: 'Player health',
        noPlayers: 'You have no registered players yet! Head over to the {0} section to adopt one.',
        playersLink: 'Players',
        liveOfTotal: '{count} of {total} live',
        onlineOfTotal: '{count} of {total} online',
        allOnline: 'All players are online.',
        playersOffline: '{count} player is offline! | {count} players are offline!',
        lastSeenLabel: 'Last seen:',
        neverSeen: 'Never seen',
        liveFootnote: '* Live players = Players which currently have a live websocket connection to the Webcy server. They can be interacted with in real-time.',
        onlineFootnote: '* Online players = Players which are online and have sent a heartbeat to the Webcy server within the last minute. They may or may not have a live websocket connection. They should respond to commands with a delay of up to 1 minute.',
        content: 'Content',
        noScreens: 'You have no screens yet! Head over to the {0} section to create one.',
        contentLink: 'Content',
        published: '{count} published',
        unpublishedChanges: '{count} with unpublished changes',
        neverPublished: '{count} never published',
        screensUnassigned: '{count} screen is not shown anywhere (not assigned to a player, playlist, schedule or trigger): | {count} screens are not shown anywhere (not assigned to a player, playlist, schedule or trigger):',
        allAssigned: 'Every screen is assigned to a player, playlist, schedule or trigger.',
        productSync: 'Product sync',
        openProductManager: 'Open product manager',
        colSource: 'Source',
        colActive: 'Active',
        colSchedule: 'Schedule',
        colLastRun: 'Last run',
        noRunsYet: 'No runs yet',
        recentActivity: 'Recent activity',
        viewAuditLog: 'View full audit log',
        noActivity: 'No activity found!',
        colDate: 'Date',
        colUser: 'User',
        colAction: 'Action',
        colSection: 'Section'
    },
    content: {
        selectAccount: 'Please select an account from the account selector in the bottom left to manage content within that account!',
        tabDynamic: 'Dynamic content',
        tabTemplates: 'Templates',
        tabAssets: 'Assets',
        tabFonts: 'Fonts',

        onlyAssigned: 'Only see dynamic content assigned to players',
        searchTemplates: 'Search templates by name, contents ...',
        searchContent: 'Search dynamic content by name, contents ...',
        loadingContent: 'Loading dynamic content ...',
        noTemplates: 'You have no templates yet! Open a piece of dynamic content and choose "Save as template" to create one.',
        noContent: 'You have no dynamic content yet!',
        addContent: '+ Add dynamic content',
        moreAddOptions: 'More add options',
        addAndConfigure: 'Add and configure ...',
        createFromTemplate: 'Create based on template ...',
        addContentTitle: 'Add dynamic content',
        iconTemplate: 'Template',
        shownOn: 'This dynamic content is currently being shown on: {names}',
        notShown: 'This dynamic content is currently not being shown on any device or player',
        edit: 'Edit ...',
        clone: 'Clone',
        previewUnpublished: 'Preview unpublished changes (if any) ...',
        viewPublic: 'View public version ...',
        editEllipsis: 'Edit ...',
        deleteEllipsis: 'Delete ...',
        openPlayerUrl: 'Open player URL ({name}) ...',
        noDescription: 'No description',
        lastPublished: 'Last published:',
        never: 'never',
        templateLabel: 'Template',
        dimsViews: '{w}x{h} - {views} views',
        published: 'Published',
        unpublishedChanges: 'Unpublished changes',
        confirmTitle: 'Confirmation',
        deleteContentMsg: 'Are you sure you wish to delete this dynamic content?  You can always retrieve it later from the recycle bin.',
        convertToPlaylist: 'Convert to playlist ...',
        convertTitle: 'Convert to playlist',
        convertExplanation: 'A new playlist is created with one item per view, in view order. Views that only contain a single image or video become image or video items; any other view is copied into its own new dynamic content. The original dynamic content is left unchanged.',
        playlistName: 'Playlist name',
        publishImmediately: 'Publish immediately',
        publishImmediatelyHint: 'Publishes the playlist and any dynamic content created for it right away. Requires publish rights.',
        convert: 'Convert',
        colResolution: 'Resolution',
        colViews: 'Views',
        colLastPublished: 'Last published',
        colStatus: 'Status',
        contentRoot: 'Dynamic content',
        moveToFolderEllipsis: 'Move to folder ...',
        deleteContentFolderMsg: 'Delete "{name}"? Its dynamic content and sub-folders will be moved up to the parent folder.',

        uploadFontFile: 'Upload font file',
        addGoogleFont: 'Add Google font',
        loadingFonts: 'Loading fonts ...',
        noFonts: "You have no custom fonts yet. Upload a font file or add a Google font — they'll then appear in the font picker of the text widget.",
        colType: 'Type',
        google: 'Google',
        uploaded: 'Uploaded',
        deleteFont: 'Delete font',
        uploadFontTitle: 'Upload font',
        fileLabel: 'File: {name}',
        fontName: 'Font name',
        fontNameHint: 'Shown in the font picker',
        upload: 'Upload',
        chooseFontFile: 'Please choose a font file ({exts}).',
        deleteFontMsg: 'Are you sure you wish to delete this font?',

        overQuotaBilled: '{mb} over quota · ${cost}',
        overQuotaBlocked: 'Over quota — uploads blocked',
        storageUsed: '{used} used',
        searchAssets: 'Search assets ...',
        gridView: 'Grid view',
        listView: 'List view',
        newFolder: 'New folder',
        uploadBtn: '+ Upload',
        loadingAssets: 'Loading assets ...',
        dropDenied: 'Dropping not accepted at this time!',
        noMatch: 'No folders or assets match your search.',
        folderEmpty: 'This folder is empty.',
        rename: 'Rename ...',
        move: 'Move ...',
        view: 'View',
        moveToFolder: 'Move to folder',
        deleteAction: 'Delete',
        hasAudioTitle: 'This video has an audio track',
        removeAudioTitle: 'Remove soundtrack',
        removeAudioConfirm: 'This video has an audio track. Remove the soundtrack? The video is replaced with a silent version (this cannot be undone).',
        removeAudioStarted: 'Removing the soundtrack… the video will update when it finishes.',
        removeAudioFailed: 'Could not start soundtrack removal.',
        removeAudioAlready: 'This video no longer has an audio track.',
        select: 'Select',
        colName: 'Name',
        colSize: 'Size',
        colAdded: 'Added',
        folderSuffix: ' — folder',
        assetsRoot: 'Assets',
        tipUsedNoLimit: '{used} used (no storage limit)',
        tipUsed: '{used} of {limit} used ({pct}%)',
        tipOverage: ' — {mb} over quota costing ${cost}',
        newFolderTitle: 'New folder',
        renameFolderTitle: 'Rename folder',
        folderName: 'Folder name',
        create: 'Create',
        renameAction: 'Rename',
        deleteFolderTitle: 'Delete folder',
        deleteFolderMsg: 'Delete "{name}"? Its assets and sub-folders will be moved up to the parent folder.',
        deleteAssetMsg: 'Are you sure you wish to delete this asset?  You can always retrieve it later from the recycle bin.',

        addWidget: 'Add widget',
        resolution: 'Resolution',
        resTrue4k: 'True 4K (4096x2160)',
        resUhd4k: 'UHD 4K (3840x2160)',
        resFullHd: 'Full HD (1920x1080)',
        resHdReady: 'HD ready (1280x720)',
        resCustom: 'Custom resolution ...',
        resVideoWalls: '— Video walls —',
        resVideoWall: 'Video wall: {name} ({width}x{height})',
        backgroundColor: 'Background color',
        portraitMode: 'Portrait mode',
        rotatedClockwise: 'Rotated clock-wise',
        createBasedOnTemplate: 'Create based on a template',
        loadingTemplates: 'Loading templates ...',
        noTemplatesYet: 'You have no templates yet. Open a piece of dynamic content and choose "Save as template" to create one.',
        useThisTemplate: 'Use this template',
        screenVersions: 'Screen versions',
        screenVersionsSubtitle: 'Here you can view and restore previous published versions of this screen.',
        loadingVersionHistory: 'Loading version history ...',
        selectPreviousVersion: 'Select a previous version',
        noVersionSelected: 'No version selected',
        publishedBy: 'Published by {name}',
        pleaseSelectVersion: 'Please select a previous version from the drop-down above.',
        noPreviousVersions: 'There are no previously published versions of this screen!',
        restoreVersion: 'Restore version',
        restoreConfirm: 'Are you sure you wish to restore this version? The current version (if unpublished) will be lost!'
    },
    editor: {
        screenSettings: 'Screen settings',
        tabGeneral: 'General',
        tabLayout: 'Layout',
        tabBehaviour: 'Behaviour',
        portraitModeSwitch: 'Screen is in portrait mode',
        clockwiseSwitch: 'Screen is rotated clock-wise',
        automaticReload: 'Automatic reload',
        reloadInterval: 'Reload interval',
        reloadIntervalHint: 'Seconds between automatic reloading of screen.  Examples: 300 = 5 minutes, 3600 = 1 hour',
        fullReload: 'Full reload',
        fullReloadHint: 'When checked, uses meta http-equiv refresh for a full page refresh.  Can clear up possible memory issues.  If not checked, only the screen data is reloaded, without a full page reload.',
        views: 'Views',
        viewsCount: 'This screen has {count} views defined.',
        addView: '+ Add view',
        pasteView: 'Paste view',
        durationNotAvailable: 'Specifying the duration is not available as this screen only has this one view.',
        whileBackgroundVideoPlays: 'While background video plays',
        seconds: 'seconds',
        transition: 'Transition',
        transitionHint: 'Specifies how this view disappears and the next one appears',
        copy: 'Copy',
        nothingInClipboard: 'Nothing in the clipboard!',
        nothingToPaste: 'There seems to be nothing to paste on the clipboard! Click "copy" next to a view below before pasting.',
        pastedSuffix: ' (pasted)',
        deleteViewConfirm: 'Are you sure you wish to delete this view?',
        couldNotCloneView: 'Could not clone this view, has it been saved?',
        viewCopied: 'View copied!',
        viewCopiedMsg: 'This view has now been copied and can be pasted by clicking the "Paste view" button above, into this screen or any other screen!',

        brandColors: 'Brand colors',
        linkedTo: 'Linked to {name}',
        clearColor: 'Clear color / Make transparent',
        border: 'Border',
        allSides: 'All sides',
        thickness: 'Thickness',
        type: 'Type',
        sliderValue: 'Value',
        offsetX: 'Offset X',
        offsetY: 'Offset Y',
        blur: 'Blur',
        borderImage: 'Border image',
        useImageAsBorder: 'Use image(s) as the border',
        sameImageAllSides: 'Same image for all sides',
        scaleRepeat: 'Scale / repeat',
        repeatStretch: 'Stretch',
        repeatRepeat: 'Repeat',
        repeatRound: 'Round (repeat & scale to whole tiles)',
        repeatSpace: 'Space (repeat with gaps)',
        addImage: 'Add an image',
        brandTypography: 'Brand typography',
        standardFonts: 'Standard fonts',
        yourFonts: 'Your fonts',
        quickSelectionAssets: 'Quick selection from assets',
        uploadFromComputer: 'Upload from your computer',
        browseYourAssets: 'Browse your assets and folders',
        browsePlus: '+ Browse ...',
        browseLibrary: 'Browse the asset library and external sources',
        externalPlus: '+ External ...',
        browseAssetsTitle: 'Browse assets',
        searchExternalLibraries: 'Search in external libraries',
        searchForAssets: 'Search for assets ...',
        uploadingAsset: 'Uploading asset to your asset library, hang on ...',
        bytesSuffix: '{size} bytes',
        loadMore: 'Load more ({count} left)',
        createNewContentTitle: 'Create new dynamic content and select it',
        newPlus: '+ New',
        createDynamicContent: 'Create dynamic content',
        createAndEdit: 'Create & edit',
        image: 'Image',
        sideTop: 'Top',
        sideRight: 'Right',
        sideBottom: 'Bottom',
        sideLeft: 'Left',
        loadingScreen: 'Loading screen ...',
        alsoEditingPre: 'This screen is also being edited by',
        alsoEditingPost: "You'll see their changes as they save — edits made at the same time can overwrite each other.",
        someone: 'Someone',
        clickToRename: 'Click to rename',
        viewsEllipsis: 'Views ...',
        versionHistory: 'Version history ...',
        saveAsTemplateTitle: 'Save as template (creates a reusable copy)',
        addWidgetTitle: 'Add widget ...',
        duplicateWidget: 'Duplicate widget',
        copyWidget: 'Copy widget',
        pasteWidget: 'Paste widget',
        deleteWidget: 'Delete widget',
        groupSelection: 'Group selection into a Widget group',
        ungroupSelection: 'Ungroup the selected Widget group',
        grid: 'Grid',
        snap: 'Snap',
        wallGuides: 'Wall guides',
        wallGuidesWall: 'Video wall',
        wallGuidesSelectTitle: 'Show guides for wall',
        align: 'Align',
        alignLeft: 'Left',
        alignRight: 'Right',
        alignTop: 'Top',
        alignBottom: 'Bottom',
        alignCenter: 'Center',
        distribute: 'Distribute (3+ widgets)',
        horizontally: 'Horizontally',
        vertically: 'Vertically',
        previewOnPlayer: 'Preview on player',
        selectedPrefix: 'Selected: {name}',
        selection: 'Selection',
        deselectAll: 'Deselect all ({name})',
        moveTool: 'Move tool — select and move widgets (V)',
        handTool: 'Hand tool — drag to pan the canvas (H, or hold Space / middle-mouse)',
        zoom: 'Zoom',
        fit: 'Fit',
        ctrlScrollZoom: 'Ctrl + scroll to zoom',
        editingInsideGroup: 'Editing inside a widget group',
        up: 'Up',
        dropMediaHere: 'Drop images or videos here to add them',
        uploadingFiles: 'Uploading {count} file(s)…',
        viewIndexOf: 'View {current} of {total}',
        dragResizePanel: 'Drag to resize the panel',
        viewSettingsTitle: 'View settings (View {current} of {total})',
        unpinPanel: 'Unpin — float the panel over the canvas',
        pinPanel: 'Pin — dock the panel',
        collapsePanel: 'Hide the panel (selecting a widget shows it again)',
        expandPanel: 'Show the settings panel',
        duration: 'Duration',
        durationLabel: 'Duration',
        durationHint: 'Specify the number of seconds this view is visible, before cycling to the next view (if any)',
        backgroundVideo: 'Background video',
        loopVideo: 'Loop video',
        backgroundImage: 'Background image',
        backgroundSize: 'Background size',
        backgroundRepeat: 'Background repeat',
        selectedWidget: 'Selected widget',
        unknownWidget: 'Unknown widget!',
        locked: 'Locked',
        positionTop: 'Position - top',
        positionLeft: 'Position - left',
        sizeWidth: 'Size - width',
        sizeHeight: 'Size - height',
        zIndex: 'Z-index',
        rotation: 'Rotation (°)',
        animation: 'Animation',
        infinite: 'Infinite',
        speed: 'Speed',
        delay: 'Delay',
        stagedDelay: 'Staged delay',
        searchWidgets: 'Search widgets ...',
        pasteHere: 'Paste here',
        noWidgetsMatch: 'No widgets match "{filter}"',
        crumbScreen: 'Screen',
        crumbGroup: 'Group',
        editingInsideCarousel: 'Editing inside a carousel',
        crumbCarousel: 'Carousel',
        crumbSlideN: 'Slide {n}',
        slides: 'Slides',
        addSlide: 'Add a slide',
        duplicateSlide: 'Duplicate this slide',
        deleteSlide: 'Delete this slide',
        deleteSlideConfirm: 'Delete this slide and everything on it?',
        moveSlideLeft: 'Move this slide earlier',
        moveSlideRight: 'Move this slide later',
        carouselFrozenHint: 'The carousel holds still while you edit; it cycles on the player.',
        carouselNoSlides: 'This carousel has no slides yet.',
        carouselNoNesting: 'A carousel cannot be placed inside another carousel.',
        containerTooDeep: 'Widgets cannot be nested any deeper than this.',
        selectSlideFirst: 'Select a slide first — widgets are placed on a slide, not on the carousel itself.',
        slideGeometryHint: 'A slide always fills its carousel, so it has no position or size of its own.',
        unpublishedChangesNotify: 'There are unpublished changes!',
        changedElsewhere: 'This screen was changed elsewhere. Save your changes or reload the page to see the latest.',
        screenUpdated: 'Screen updated ...',
        savingScreen: 'Saving screen ...',
        savingAsTemplate: 'Saving as template ...',
        savedAsTemplate: 'Saved as template.',
        publishingScreen: 'Publishing screen ...',
        schedulingPublish: 'Scheduling publish ...',
        deleteWidgetsConfirm: 'Are you sure you wish to delete the selected widgets?',
        onlyImageVideo: 'Only image and video files can be dropped onto a screen.',
        videoWidgetNotAvailable: 'The video widget is not available.',
        imageWidgetNotAvailable: 'The image widget is not available.',
        uploadFailed: 'Upload of {name} failed.',
        widgetCopied: 'Widget copied!',
        widgetCopiedMsg: 'The selected widget(s) have been copied and can be pasted into this screen or any other screen!',
        nothingToPasteWidget: 'There seems to be nothing to paste on the clipboard!  Select a widget and click copy before pasting.'
    },
    animations: {
        bounce: 'Bounce',
        flash: 'Flash',
        pulse: 'Pulse',
        shake: 'Shake',
        swing: 'Swing',
        tada: 'Tada!',
        wobble: 'Wobble',
        jello: 'Jello',
        hinge: 'Hinge',
        rubberBand: 'Rubber band',
        headShake: 'Head shake',
        bounceIn: 'Bounce in',
        bounceInDown: 'Bounce in and down',
        bounceInLeft: 'Bounce in from the left',
        bounceInRight: 'Bounce in from the right',
        bounceInUp: 'Bounce in and up',
        bounceOut: 'Bounce out',
        bounceOutDown: 'Bounce out and down',
        bounceOutLeft: 'Bounce out from the left',
        bounceOutRight: 'Bounce out from the right',
        bounceOutUp: 'Bounce out and up',
        fadeIn: 'Fade in',
        fadeInDown: 'Fade in and down',
        fadeInDownBig: 'Fade in and down (big)',
        fadeInLeft: 'Fade in from the left',
        fadeInLeftBig: 'Fade in from the left (big)',
        fadeInRight: 'Fade in from the right',
        fadeInRightBig: 'Fade in from the right (big)',
        fadeInUp: 'Fade in and up',
        fadeInUpBig: 'Fade in and up (big)',
        fadeOut: 'Fade out',
        fadeOutDown: 'Fade out and down',
        fadeOutDownBig: 'Fade out and down (big)',
        fadeOutLeft: 'Fade out from the left',
        fadeOutLeftBig: 'Fade out from the left (big)',
        fadeOutRight: 'Fade out from the right',
        fadeOutRightBig: 'Fade out from the right (big)',
        fadeOutUp: 'Fade out and up',
        fadeOutUpBig: 'Fade out and up (big)',
        flipInX: 'Flip in - X axis',
        flipInY: 'Flip in - Y axis',
        flipOutX: 'Flip out - X axis',
        flipOutY: 'Flip out - Y axis',
        lightSpeedIn: 'Light speed in',
        lightSpeedOut: 'Light speed out',
        rotateIn: 'Rotate in',
        rotateInDownLeft: 'Rotate in down/left',
        rotateInDownRight: 'Rotate in down/right',
        rotateInUpLeft: 'Rotate in up/left',
        rotateInUpRight: 'Rotate in up/right',
        rotateOut: 'Rotate out',
        rotateOutDownLeft: 'Rotate out down/left',
        rotateOutDownRight: 'Rotate out down/right',
        rotateOutUpLeft: 'Rotate out up/left',
        rotateOutUpRight: 'Rotate out up/right',
        jackInTheBox: 'Jack in the box',
        rollIn: 'Roll in',
        rollOut: 'Roll out',
        zoomIn: 'Zoom in',
        zoomInDown: 'Zoom in and down',
        zoomInLeft: 'Zoom in from the left',
        zoomInRight: 'Zoom in from the right',
        zoomInUp: 'Zoom in and up',
        zoomOut: 'Zoom out',
        zoomOutDown: 'Zoom out and down',
        zoomOutLeft: 'Zoom out and left',
        zoomOutRight: 'Zoom out and right',
        zoomOutUp: 'Zoom out and up',
        slideInDown: 'Slide in and down',
        slideInLeft: 'Slide in from the left',
        slideInRight: 'Slide in from the right',
        slideInUp: 'Slide in and up',
        slideOutDown: 'Slide out and down',
        slideOutLeft: 'Slide out from the left',
        slideOutRight: 'Slide out from the right',
        slideOutUp: 'Slide out and up'
    },
    qr: {
        editQrCode: 'Edit QR code',
        typeOfQrCode: 'Type of QR code',
        typeWebsite: 'Website URL',
        typeText: 'General text',
        typeWifi: 'WIFI Network information',
        typeVcard: 'Contact information',
        typeEmail: 'Send e-mail',
        typePhone: 'Make phone call',
        typeSms: 'Send SMS message',
        typeGeo: 'Geolocation',
        typeVcalendar: 'Event information',
        typeNumber: 'General number',
        typePlayStore: 'Link to app on Google Play Store',
        typeAppStore: 'Link to app on iOS App store',
        appStoreId: 'Application ID in the App store',
        playStoreId: 'Application ID in the Play store',
        emailAddress: 'E-mail address',
        latitude: 'Latitude',
        longitude: 'Longitude',
        number: 'Number',
        phoneNumber: 'Phone number',
        smsTo: 'To',
        smsMessage: 'Message',
        textMessage: 'Text message',
        summary: 'Summary',
        startDate: 'Start date',
        startTime: 'Start time',
        endDate: 'End date',
        endTime: 'End time',
        location: 'Location',
        firstName: 'First name',
        lastName: 'Last name',
        telephone: 'Telephone',
        websiteUrl: 'Website URL',
        networkName: 'Network name',
        networkPassword: 'Network password'
    },
    productWidget: {
        noProductsSelected: 'No products selected!',
        productNotFound: 'Product not found!',
        addPlus: '+ Add',
        showBySku: 'Show product by SKU',
        showByTitle: 'Show product by title',
        customizeAppearance: "Customise this product's appearance (otherwise it follows the grid)",
        layout: 'Layout',
        titleSize: 'Title size',
        photoOffset: 'Photo offset',
        photoSize: 'Photo size',
        spacing: 'Spacing',
        imageAbove: 'Image above',
        imageLeft: 'Image to the left',
        imageRight: 'Image to the right',
        fontColor: 'Font color',
        dataToShow: 'Data to show',
        hidePhoto: 'Hide photo',
        hideTitle: 'Hide title',
        hideShortDescription: 'Hide short description',
        hidePrice: 'Hide price',
        hidePriceDescriptions: 'Hide price descriptions',
        hideTags: 'Hide tags',
        overrides: 'Overrides',
        overrideTitle: 'Override title',
        overrideDescription: 'Override description',
        overridePhoto: 'Override photo',
        overridePhotoUrl: 'Override photo url',
        overrideTags: 'Override tags',
        removeProductConfirm: 'Are you sure you wish to remove this product?',
        overrideName: 'Override name',
        unit: 'Unit',
        showImage: 'Show image',
        showTags: 'Show tags',
        store: 'Store',
        product: 'Product',
        cannotFindProduct: 'Cannot find a product? Clear cache',
        linkBySku: 'Link by SKU ({sku})',
        linkByName: 'Link by name ({name})',
        cacheCleared: 'Product and offer cache cleared!',
        cacheClearedMsg: 'Click OK and the product list will be reloaded.',
        chartSeries: 'Series',
        chartRemoveSeries: 'Remove series',
        chartAddSeries: 'Add series',
        chartLabel: 'Label',
        chartRemoveRow: 'Remove row',
        chartAddRow: 'Add row',
        chartSeriesN: 'Series {n}',
        chartItemN: 'Item {n}',
        loadingProduct: 'Loading product ...'
    },
    tableEditor: {
        title: 'Edit table',
        editTable: 'Edit table',
        summary: '{rows} rows × {columns} columns',
        emptyTable: 'Empty table',
        tabGrid: 'Table',
        tabPaste: 'Paste from Excel',
        apply: 'Apply',
        undo: 'Undo',
        redo: 'Redo',
        insertRow: 'Insert row',
        insertColumn: 'Insert column',
        deleteRow: 'Delete rows',
        deleteColumn: 'Delete columns',
        bold: 'Bold',
        italic: 'Italic',
        underline: 'Underline',
        textColor: 'Text color',
        fillColor: 'Fill color',
        clearColor: 'No color',
        alignLeft: 'Align left',
        alignCenter: 'Align center',
        alignRight: 'Align right',
        clearFormatting: 'Clear formatting',
        headerRow: 'First row is a header',
        trimEmpty: 'Trim empty',
        trimEmptyHint: 'Remove empty rows and columns from the end of the table',
        keyboardHint: 'Double-click or press Enter to edit a cell. Drag to select a range. Ctrl+C, Ctrl+V to copy and paste.',
        pasteHint: 'Copy a block of cells in Excel or Google Sheets, then paste it into the box below. Use this when you want to replace the whole table, or when your data is a CSV file.',
        pastePlaceholder: 'Paste your data here',
        pastePreview: 'Recognised {rows} rows × {columns} columns',
        pasteTooLarge: 'That is too much data to paste at once. Paste it in smaller blocks.',
        delimiter: 'Columns separated by',
        delimiterTab: 'Tab (copied from a spreadsheet)',
        delimiterComma: 'Comma',
        delimiterSemicolon: 'Semicolon',
        trimWhitespace: 'Trim spaces',
        firstRowIsHeader: 'First row is a header',
        replaceTable: 'Replace table',
        appendRows: 'Add to the bottom',
        truncated: 'Only the first {rows} rows and {columns} columns were kept. A table can hold at most {maxRows} rows and {maxColumns} columns.',
        manyRows: 'This table has {rows} rows. Tables over {warn} rows can be slow to load and hard to read on a screen.'
    },
    iconPicker: {
        title: 'Choose an icon',
        search: 'Search icons',
        all: 'All',
        solid: 'Solid',
        regular: 'Regular',
        brands: 'Brands',
        noMatches: 'No icons match. Try another word, in English.',
        showingSome: 'Showing {shown} of {total} icons. Type to narrow it down.',
        none: 'No icon chosen',
        choose: 'Choose icon',
    },
    scheduleWidget: {
        itemLegends: 'Legends',
        addLegend: 'Add a legend icon',
        removeLegend: 'Remove this legend',
        editNames: 'Edit names',
        namesNone: 'The language\'s own names.',
        namesOverridden: '{n} name of your own | {n} names of your own',
        namesTitle: 'Day and month names',
        namesIntro: 'Type a name to use it instead of the language\'s own — for a language that isn\'t in the list, or a different wording. Empty boxes keep the name shown in grey.',
        namesDays: 'Days',
        namesMonths: 'Months',
        namesClear: 'Clear all',
        title: 'Daily schedule',
        editSchedule: 'Edit schedule',
        apply: 'Apply',
        modeEveryDay: 'Same every day',
        modePerDay: 'Different each day',
        everyDay: 'Every day',
        itemCount: '{count} item(s)',
        emptySchedule: 'Nothing scheduled yet.',
        noItemsYet: 'Nothing on this day yet.',
        addItem: 'Add item',
        startTime: 'From',
        endTime: 'To',
        itemTitle: 'Title',
        itemDescription: 'Description',
        sortNote: 'Times are 24-hour, e.g. 09:00 or 17:30. Items are sorted by start time automatically. Leave "To" empty for something with no set finish.',
        copyDayTo: 'Copy {0}\'s items to:',
        copyButton: 'Copy',
        copyReplaces: 'This replaces whatever those days currently hold.'
    },
    widgets: {
        weatherUnavailable: 'Weather unavailable',
        loadingWeather: 'Loading weather ...',
        setTargetDate: 'Set a target date',
        days: 'Days',
        hours: 'Hours',
        minutes: 'Minutes',
        seconds: 'Seconds',
        couldNotLoadFeed: 'Could not load feed',
        noFeedItems: 'No feed items',
        noImageSelected: 'No image selected',
        noImagesSelected: 'No images selected',
        noVideoSelected: 'No video selected',
        clickToSelect: 'Click here to select widget',
        noData: 'No data',
        dataValueUnbound: 'Choose a data source',
        dataValueUpdated: 'Updated {time}',
        dataListUnbound: 'Choose a data source in the widget settings',
        noProductSpecified: 'No product specified',
        weather: {
            unknown: '—',
            clear: 'Clear',
            mainlyClear: 'Mainly clear',
            partlyCloudy: 'Partly cloudy',
            overcast: 'Overcast',
            fog: 'Fog',
            rimeFog: 'Rime fog',
            lightDrizzle: 'Light drizzle',
            drizzle: 'Drizzle',
            heavyDrizzle: 'Heavy drizzle',
            freezingDrizzle: 'Freezing drizzle',
            lightRain: 'Light rain',
            rain: 'Rain',
            heavyRain: 'Heavy rain',
            freezingRain: 'Freezing rain',
            lightSnow: 'Light snow',
            snow: 'Snow',
            heavySnow: 'Heavy snow',
            snowGrains: 'Snow grains',
            rainShowers: 'Rain showers',
            heavyShowers: 'Heavy showers',
            snowShowers: 'Snow showers',
            thunderstorm: 'Thunderstorm'
        }
    },
    notifications: {
        title: 'All notifications',
        loading: 'Loading notifications ...',
        search: 'Search notifications',
        none: 'No notifications found!',
        noneShort: 'No notifications!',
        markRead: 'Mark as read',
        markUnread: 'Mark as unread',
        loadMore: '({loaded} of {total}) - Load 50 more',
        deleteAll: 'Delete all',
        deleteSelected: 'Delete selected',
        markAllRead: 'Mark all as read',
        seeAll: 'See all ...',
        confirmDelete: 'Are you sure you wish to delete this notification?',
        confirmDeleteAll: 'Are you sure you wish to delete all notifications?',
        confirmDeleteSelected: 'Are you sure you wish to delete the selected notifications?',
        confirmMarkAllRead: 'Are you sure you wish to mark all notifications as read?'
    },
    formFields: {
        none: 'No fields yet.',
        templateBanner: 'Banner',
        templateSingle: 'Single value',
        edit: 'Edit fields',
        title: 'Form fields',
        intro: 'What staff fill in. A banner needs a switch, the text, a style and (optionally) when to hide it — the Banner starting point has them all.',
        label: 'Label',
        type: 'Type',
        key: 'Name in templates',
        moveUp: 'Move up',
        options: 'Options',
        optionsHint: 'Type an option and press Enter.',
        add: 'Add a field',
        keyNote: 'The name in templates is how a widget shows the value, e.g. {example}. Changing it breaks widgets that already use it.',
        problemNone: 'Add at least one field.',
        problemTooMany: 'A form can have at most {max} fields.',
        problemKey: '"{key}" can\'t be used as a name: start with a letter, then letters, digits or _.',
        problemDuplicate: 'Two fields are called "{key}".',
        problemOptions: 'Give "{label}" at least one option.',
        bannerActive: 'Show the banner',
        bannerText: 'Text',
        bannerStyle: 'Style',
        bannerUntil: 'Hide automatically at',
        singleValue: 'Value',
        types: {
            toggle: 'On/off switch',
            text: 'Text',
            longtext: 'Longer text',
            number: 'Number',
            choice: 'Choice',
            datetime: 'Date and time',
        },
    },
    quickEdit: {
        title: 'Quick edit',
        signOut: 'Sign out',
        noForms: 'There are no forms for you to fill in yet. Ask the person who manages your screens.',
        lastSaved: 'Last saved {when}',
        back: 'Back',
        paused: 'This form is paused in Webcy, so it can\'t be saved now.',
        previewEmpty: '(no text yet)',
        previewOff: 'The banner is off: nothing shows on the screens.',
        inAnHour: 'In an hour',
        endOfDay: 'End of day',
        noTime: 'No time',
        save: 'Save',
        saved: 'Saved — screens update in a few seconds.',
        loadFailed: 'This couldn\'t be loaded. Check your connection and try again.',
        saveFailed: 'This couldn\'t be saved. Check your connection and try again.',
        linkBroken: 'This link doesn\'t work any more. Ask for a new one.',
        choices: {
            info: 'Info',
            warning: 'Warning',
            urgent: 'Urgent',
        },
    },
    bannerWidget: {
        hiddenOnScreens: 'Hidden on screens',
        sampleText: 'The banner text appears here',
    },
    access: {
        quickEdit: 'Quick edit (forms only)',
        quickEditDesc: 'Can only fill in this account\'s forms (e.g. switch a banner on and change its text) on the quick edit page — no access to screens, devices or settings.',
        account: 'Account',
        accessLevel: 'Access level',
        noAccessSpecified: 'No account access specified!',
        editor: 'Editor',
        publisher: 'Publisher',
        owner: 'Owner',
        noAccess: 'No Access',
        editorDesc: 'User has access to edit screens, but cannot publish changes.',
        publisherDesc: 'User has access to edit and publish screens.',
        ownerDesc: 'User has full access to everything within this account and can invite new team members.',
        noAccessDesc: 'Access will be revoked - the user will lose all access to this account.  You can invite the user again anytime you want.'
    },
    accounts: {
        assetSettings: 'Asset settings',
        editAccount: 'Edit account',
        addAccount: 'Add account',
        keywords: 'Keywords',
        subscriptionPlan: 'Subscription plan',
        subscriptionHint: 'Leave empty for no plan (unlimited, like existing accounts).',
        subscriptionActive: 'Subscription active / paid',
        inactiveSuffix: ' (inactive)',
        playersWord: 'players',
        storageWord: 'storage',
        editUser: 'Edit user',
        addUser: 'Add user',
        adminPrivileges: 'Administrator priviliges',
        changePasswordTitle: 'Change password',
        newPassword: 'New password',
        repeatPassword: 'Repeat password',
        confirmPassword: 'Confirm password'
    },
    team: {
        invite: 'Invite team member',
        inviteIntro: 'Here you can invite people to collaborate with you in the {0} account.',
        emailLabel: 'E-mail address',
        emailHint: "Type in the e-mail address of the person you'd like to invite",
        selectPermissions: 'Select the appropriate permissions for the new team member:',
        expiryIntro: 'For added security, letting the invitation link expire after a given amount of time might be a good idea.  When would you like it to expire?',
        sendInvitation: 'Send invitation',
        accountPermissions: 'Account permissions',
        confirmRemoveAccess: 'Are you sure you wish to remove all access to this account for the selected user?',
        expireNever: 'Link never expires - only when it has been used',
        expire1h: 'After one hour',
        expire2h: 'After two hours',
        expire4h: 'After four hours',
        expire8h: 'After eight hours',
        expire1d: 'After one day (24 hours)',
        expire2d: 'After two days (48 hours)',
        expire1w: 'After a week'
    },
    admin: {
        searchPlaceholder: 'Search ...',
        colCreated: 'Created',
        colModified: 'Modified',
        colLastLogin: 'Last login',
        changePassword: 'Change password',
        confirmDeleteAccounts: 'Are you sure you wish to delete the selected account(s)?',
        confirmDeleteUsers: 'Are you sure you wish to delete the selected users(s)?',
        invite: 'Invite',
        editPermissions: 'Edit permissions',
        pendingInvitations: 'Pending invitations',
        sentTo: 'Sent to',
        expires: 'Expires',
        neverExpires: 'Never expires',
        tabAccounts: 'Accounts',
        tabUsers: 'Users',
        tabErrorLogs: 'Error logs',
        subTabServerErrors: 'Server errors',
        subTabClientErrors: 'Client/player errors',
        tabDataTransfer: 'Data transfer',
        tabS3: 'S3 storage',
        tabSubscriptions: 'Subscriptions',
        tabInvoices: 'Invoices',
        tabBackgroundJobs: 'Background jobs',
        tabGlobalSettings: 'Global settings',
        tabVideoTools: 'Video tools',
        hangfireDashboard: 'Hangfire dashboard',
        hangfireDesc: 'Hangfire background-jobs dashboard (recurring billing, product syncs, scheduled publishes).',
        openInNewTab: 'Open in new tab'
    },
    views: {
        selectPlayers: 'Please select an account from the account selector in the bottom left to manage players within that account!',
        selectSchedules: 'Please select an account from the account selector in the bottom left to manage schedules within that account!',
        selectTriggers: 'Please select an account from the account selector in the bottom left to manage triggers within that account!',
        selectBrandKits: 'Please select an account from the account selector in the bottom left to manage brand kits within that account!',
        selectPlaylists: 'Please select an account from the account selector in the bottom left to manage playlists within that account!',
        selectThemes: 'Please select an account from the account selector in the bottom left to manage themes within that account!',
        selectProducts: 'Please select an account from the account selector in the bottom left to manage products within that account!',
        selectAnalytics: 'Please select an account from the account selector in the bottom left to view analytics for that account!'
    },
    settings: {
        mcpSettings: 'MCP settings',
        selectAccount: 'Please select an account from the account selector in the bottom left to manage settings within that account!',
        saveSettings: 'Save settings',
        noEditor: 'Could not find an editor for type {type}',
        saving: 'Saving settings ...',
        saved: 'Settings saved!'
    },
    mcp: {
        title: 'MCP access keys',
        createKey: 'Create key',
        subtitle: 'API keys let AI agents (via the MCP server at {0}) manage playlists, screens and assets in this account. Treat keys like passwords — the full token is shown only once.',
        colPrefix: 'Prefix',
        colAccess: 'Access',
        colLastUsed: 'Last used',
        colStatus: 'Status',
        never: 'Never',
        revoked: 'Revoked',
        noKeys: 'No keys yet.',
        createTitle: 'Create MCP access key',
        copyWarning: 'Copy this token now — it will not be shown again.',
        token: 'Token',
        done: 'Done',
        loadFailed: 'Failed to load keys.',
        createFailed: 'Failed to create key.',
        revokeConfirm: 'Revoke key "{name}"? Agents using it will stop working.',
        keyRevoked: 'Key revoked.',
        revokeFailed: 'Failed to revoke key.',
        tokenCopied: 'Token copied to clipboard.'
    },
    storage: {
        migrateBtn: 'Migrate existing assets to this provider',
        migrateDesc: 'Copies every asset in this account into the selected store (read from wherever it currently lives). Runs in the background — you can keep working. Save the setting afterwards.',
        queued: 'Queued…',
        migrating: 'Migrating…',
        complete: 'Migration complete.',
        failed: 'Migration failed.',
        migratedStats: 'Migrated {migrated}, skipped {skipped} (already present), failed {failed}.',
        andMore: '…and {count} more',
        migrateTitle: 'Migrate assets',
        migrateConfirm: 'Copy ALL assets for this account into "{provider}"? Each asset is read from wherever it currently lives and written to the selected store. This runs in the background.',
        couldNotStart: 'Could not start migration.',
        browseBtn: 'Browse storage',
        browserTitle: 'Storage browser',
        root: 'Root',
        colName: 'Name',
        colType: 'Type',
        colSize: 'Size',
        colModified: 'Modified',
        typeFolder: 'Folder',
        typeFile: 'File',
        totalSize: 'Total: {size} across {count} objects',
        calculating: 'Calculating total…',
        empty: 'This folder is empty.',
        truncated: 'Showing the first results only — this folder has more entries than can be displayed.'
    },
    subscriptionsAdmin: {
        editPlan: 'Edit subscription plan',
        createPlan: 'Create subscription plan',
        maxPlayers: 'Max players',
        maxPlayersHint: 'Devices + players combined. Leave blank for unlimited.',
        minPlayers: 'Minimum players (billing floor)',
        minPlayersHint: 'Bill for at least this many players even if fewer are in use. Leave blank for no minimum.',
        maxStorage: 'Max storage (GB)',
        maxStorageHint: 'Total size of stored assets. Leave blank for unlimited.',
        maxAiImages: 'AI images per month',
        maxAiImagesHint: 'Maximum AI-generated images per calendar month. Leave blank for unlimited.',
        monthlyPrice: 'Monthly price per player',
        pricePerMb: 'Price per MB over quota',
        pricePerMbHint: 'Leave blank to block uploads at the storage limit instead of charging for overage.',
        features: 'Features',
        aiIntegration: 'AI integration',
        aiHint: "AI chat assistant and brand-kit 'analyze from website'.",
        brandKits: 'Brand kits',
        productIntegrations: 'Product integrations/Analytics',
        dataSources: 'Data sources',
        activeHint: 'Inactive plans are hidden from the account assignment dropdown.',
        colMaxPlayers: 'Max players',
        colMinPlayers: 'Min players',
        colMaxStorage: 'Max storage',
        colPricePlayer: 'Price / player',
        colOverage: 'Overage',
        colFeatures: 'Features',
        colAccounts: 'Accounts',
        unlimited: 'Unlimited',
        blocked: 'Blocked',
        deletePlanTitle: 'Delete subscription plan',
        deletePlanMsg: 'Delete "{name}"? This is only allowed if no accounts are assigned to it.',
        featAi: 'AI',
        featBrandKits: 'Brand kits',
        featProducts: 'Products',
        featDataSources: 'Data sources'
    },
    audit: {
        detailsTitle: 'Audit entry details',
        colDateTime: 'Date/time',
        colUser: 'User',
        colAction: 'Action',
        colController: 'Controller',
        colRemoteIp: 'Remote IP',
        colHost: 'Host',
        actionArguments: 'Arguments',
        queryString: 'Query string',
        formData: 'Form data',
        httpHeaders: 'HTTP headers',
        nothingRecorded: 'Nothing else was recorded for this request.'
    },
    errorLog: {
        filterByDevice: 'Filter by device',
        colDateTime: 'Date/time',
        colAccount: 'Account',
        colDevice: 'Device',
        colMessage: 'Message',
        colVM: 'VM',
        colInfo: 'Info'
    },
    serverErrors: {
        title: 'Server errors',
        detailsTitle: 'Error details',
        noDetails: 'No details available for this error.',
        filterLevel: 'Level',
        levelAll: 'All levels',
        refresh: 'Refresh',
        colDateTime: 'Date/time',
        colLevel: 'Level',
        colSource: 'Source',
        colMessage: 'Message',
        colPath: 'Request',
        colUser: 'User',
        colMachine: 'Server'
    },
    videoTools: {
        title: 'Video tools',
        description: 'Optional ffmpeg toolchain used to detect and remove audio tracks from uploaded videos. Install it here; nothing is downloaded until you do.',
        note: 'Once installed, newly uploaded videos are checked for an audio track, and a "Remove soundtrack" action appears for videos that have one.',
        install: 'Install',
        reinstall: 'Reinstall',
        installFailed: 'Could not start the installation.',
        statusLoading: 'Checking status…',
        statusInstalled: 'Video tools are installed.',
        statusDownloading: 'Downloading and installing…',
        statusFailed: 'Installation failed.',
        statusNotInstalled: 'Video tools are not installed.'
    },
    recycleBin: {
        selectAccount: 'Please select an account from the account selector in the bottom left to manage the recycle bin within that account!',
        loading: 'Loading recycle bin ...',
        empty: 'The recycle bin is empty!',
        colType: 'Type',
        colTitle: 'Title',
        colDeleted: 'Deleted',
        unknown: 'Unknown',
        restore: 'Restore',
        deleteForever: 'Delete forever',
        typeScreen: 'Screen',
        typePlaylist: 'Playlist',
        typeTheme: 'Theme',
        typeAsset: 'Asset',
        typeSchedule: 'Schedule',
        typeTrigger: 'Trigger',
        typeDevice: 'Player',
        typeDeviceGroup: 'Player group',
        typeProduct: 'Product',
        purgeConfirm: 'Are you sure you wish to permanently delete the {type} "{title}"?  This cannot be undone!'
    },
    s3: {
        editConfig: 'Edit S3 configuration',
        addConfig: 'Add S3 configuration',
        nameHint: "Shown in the storage provider dropdown as 'S3: <name>'",
        serviceUrl: 'Service URL',
        serviceUrlHint: 'Custom endpoint for R2/MinIO/Spaces/Hetzner; leave empty for real AWS (Region is used instead)',
        region: 'Region',
        regionHint: 'Only used when Service URL is empty, e.g. eu-west-1',
        accessKey: 'Access key',
        secret: 'Secret',
        bucket: 'Bucket',
        publicBaseUrl: 'Public base URL',
        publicBaseUrlHint: 'Optional CDN/public domain pointing at the bucket root; required for Cloudflare R2 (its S3 API endpoint is never publicly readable)',
        forcePathStyle: 'Force path-style addressing',
        forcePathStyleHint: 'Enable for MinIO-style endpoints',
        publicReadAcl: 'Set public-read ACL on uploads',
        publicReadAclHint: 'Only for legacy ACL-enabled AWS buckets; modern buckets (and R2) reject ACLs and use a public-read bucket policy instead',
        activeHint: 'Inactive configurations are hidden from the storage provider dropdown. Accounts already assigned to this configuration will stop resolving their assets while it is inactive.',
        testConnection: 'Test connection',
        colEndpoint: 'Endpoint',
        deleteTitle: 'Delete S3 configuration',
        deleteMsg: 'Delete "{name}"? Any account whose storage provider is set to this configuration will immediately lose access to its assets - uploads will fail and existing assets will stop loading - until the account is moved to another provider. The files in the bucket itself are NOT deleted. This cannot be undone.',
        testFailed: 'Test request failed'
    },
    dataTransfer: {
        title: 'Data transfer',
        from: 'From',
        to: 'To',
        totalLine: 'Total for this view: {0} across {1} requests.',
        cdnLine: '— {0} offloaded via CDN (not origin egress).',
        byAsset: 'Data transfer by asset',
        colType: 'Type',
        colRequests: 'Requests',
        colData: 'Data transferred',
        noData: 'No data transfer recorded for this period.',
        accounts: 'Accounts',
        otherFiles: 'Other ({count} files)'
    },
    analytics: {
        title: 'Product analytics',
        showFor: 'Show for',
        infoLine: 'Proof of playback: how much screen time each product got in this period. {0} impressions across {1} products, totalling {2} of exposure.',
        topProducts: 'Top products by exposure time',
        colProduct: 'Product',
        colImpressions: 'Impressions',
        colExposure: 'Exposure',
        colLastShown: 'Last shown',
        noData: 'No product impressions recorded for this period.',
        allDevicesPlayers: 'All devices & players',
        groups: 'Groups',
        devices: 'Devices',
        players: 'Players',
        minutesOfExposure: 'Minutes of exposure',
        exposureMin: 'Exposure (min)'
    },
    products: {
        addProduct: '+ Add product',
        cardView: 'Card view',
        listView: 'List view',
        searchPlaceholder: 'Search ...',
        noProducts: 'You have not added any products yet.  Manually create some products by clicking the "Add product" button above, or set up an external product source by clicking "Product sources".',
        sku: 'SKU',
        skuPrefix: 'SKU:',
        noPhoto: 'No photo',
        noTags: 'No tags',
        priceTitle: 'Price',
        offerPriceTitle: 'Offer Price',
        colTags: 'Tags',
        colPrice: 'Price',
        colModified: 'Modified',
        colSource: 'Source',
        prevPage: 'Prev page',
        nextPage: 'Next page',
        pageOf: 'Page {current} of {total}',
        deleteConfirm: 'Are you sure you wish to delete the selected products(s)?  You can always retrieve them later from the recycle bin.',
        editProduct: 'Edit product',
        addProductTitle: 'Add product',
        protectedInfoPrefix: "Your edits to the following fields are protected and won't be overwritten when products are synced from {source}:",
        protectedInfoSuffix: 'All other fields keep updating from the source.',
        resetToSource: 'Reset to source',
        syncedInfo: 'This product is synced from an external product source ({source}). Any field you change here will be protected and kept the next time products from that source are imported.',
        skuHint: 'Stock keeping unit - a unique product identifier',
        shortDescription: 'Short description',
        prices: 'Prices',
        variationDescription: 'Variation/description',
        amount: 'Amount',
        addPrice: '+ Add price',
        offerPrices: 'Offer prices',
        tags: 'Tags',
        photo: 'Photo',
        photoUrl: 'Photo URL (for referencing external images)',
        updateProduct: 'Update product',
        createProduct: 'Create product',
        removePriceConfirm: 'Are you sure you wish to remove this price?',
        productSourcesBtn: 'Product sources ...',
        externalSourcesTitle: 'External product sources',
        noSourcesYet: 'You have not set up any external product sources yet.',
        addNow: 'Add now!',
        colStatus: 'Status',
        colSchedule: 'Schedule',
        colLastRun: 'Last run',
        running: 'Running ...',
        initialized: 'Initialized',
        initPending: 'Initialization pending ...',
        deactivated: 'Deactivated',
        noRuns: 'No runs yet',
        runNow: 'Run now!',
        addAnotherSource: '+ Add another source ...',
        addSourceTitle: 'Add external product source',
        editSourceTitle: 'Edit external product source',
        selectSourcePrompt: "Select which source you'd like to add:",
        noAvailableSources: 'There are no available product sources!',
        pickDifferent: 'Pick a different one?',
        additionalOptions: 'The product source "{name}" has these additional options which need to be configured for it to work properly.',
        recurrencePlaceholder: 'How frequently should the products from this source be fetched',
        recurrenceInterval: 'Recurrence interval',
        atTime: 'At (time)',
        atTimeHint: 'The time when the products should be fetched (Empty = midnight)',
        atMinute: 'At (minute)',
        atMinuteHint: 'The minute when the products should be fetched (Empty = first minute of every hour)',
        everyXMinute: 'Every x minute',
        everyXMinuteHint: 'Nr of minutes between runs',
        runImmediately: 'Run immediately and then according to the specified interval',
        isActive: 'Is Active',
        deleteSourceConfirm: 'Are you sure you wish to delete this product source?  NOTE: Products which have been added via this source will not be deleted.',
        minutely: 'Minutely',
        hourly: 'Hourly',
        daily: 'Daily'
    },
    assets: {
        filesInQueue: '{count} file(s) in the upload queue!',
        statusQueued: 'Queued',
        statusUploading: 'Uploading',
        statusFinalizing: 'Finalizing',
        statusFinished: 'Finished',
        statusFailed: 'Failed',
        uploadTitle: 'Upload',
        removeFromQueue: 'Remove from queue',
        retry: 'Retry!',
        errorUploading: 'Error uploading!',
        dropHere: 'Drop the file(s) here to upload!',
        moveToFolder: 'Move to folder',
        rootNoFolder: 'Root (no folder)',
        generateImage: 'Generate image',
        generateImageTitle: 'Generate image with AI',
        imagePrompt: 'Describe the image',
        imagePromptHint: 'Be specific about the subject, style, colours and composition. Avoid asking for text in the image.',
        orientation: 'Orientation',
        orientationLandscape: 'Landscape',
        orientationPortrait: 'Portrait',
        orientationSquare: 'Square',
        imagesUsed: '{used} of {limit} AI images used this month',
        generatingHint: 'Generating the image can take up to a minute ...',
        generate: 'Generate',
        generateAnother: 'Generate another',
        done: 'Done'
    },
    fonts: {
        addGoogleFont: 'Add a Google font',
        notConfiguredPre: "Google Fonts browsing isn't configured. An administrator needs to set a Google Web Fonts API key",
        notConfiguredPost: 'on the server. You can still upload your own font files.',
        searchPlaceholder: 'Search Google Fonts (e.g. Lobster) ...',
        searching: 'Searching Google Fonts ...',
        viewOnGoogle: 'View on Google Fonts',
        add: 'Add',
        added: 'Added',
        noMatch: 'No fonts match your search.'
    },
    textPicker: {
        select: 'Select data',
        selectHint: 'Pick a value from the data source to show in the text',
        title: 'Select data',
        text: 'Text',
        result: 'How it reads on the screen',
        format: 'Show values as',
        pick: 'Data',
        pickHint: 'Click a value to put it in the text at the cursor. The figures are from the data right now.',
        count: 'Number of records',
        example: 'Example',
        show: 'Show',
        value: 'Value',
        lastHint: 'The value in the last record (after filtering and sorting)',
        noFields: 'The data source has no fields yet. Fetch it first.'
    },
    dataBinding: {
        boundToSource: 'A data source',
        notBound: 'Not connected to a data source',
        bind: 'Choose data source',
        edit: 'Edit',
        remove: 'Remove',
        title: 'Data source',
        noSources: 'There are no data sources yet. Add one under Data sources in the menu.',
        notInPlan: 'Data sources aren\'t included in your plan.',
        source: 'Data source',
        missingFields: 'Not in the latest data: {fields}. Check the field names, or wait for the next fetch.',
        whichRecords: 'Which records',
        field: 'Field',
        condition: 'Condition',
        value: 'Value',
        addFilter: 'Add condition',
        sortBy: 'Sort by',
        thenBy: 'then by',
        addSort: 'Add sorting',
        ascending: 'Ascending',
        descending: 'Descending',
        limit: 'At most',
        limitHint: 'records (up to 500)',
        columns: 'Columns',
        addAllFields: 'Add all fields',
        noColumns: 'No columns chosen: every field is shown.',
        caption: 'Heading',
        align: 'Align',
        align_left: 'Left',
        align_center: 'Center',
        align_right: 'Right',
        widthPercent: 'Width %',
        addColumn: 'Add column',
        showHeader: 'Show a heading row',
        whatToShow: 'What to show',
        show: 'Show',
        thresholds: 'Colour thresholds',
        thresholdsHint: 'The first condition the value meets sets its colour.',
        color: 'Colour',
        addThreshold: 'Add threshold',
        chartSeries: 'Chart',
        categoryField: 'Category',
        categoryFieldHint: 'One bar, point or slice per distinct value of this field.',
        valueField: 'Value',
        seriesName: 'Series name',
        addSeries: 'Add series',
        textTemplate: 'Text',
        textIntro: 'Type the text in the widget\'s Text setting, with placeholders for the data:',
        syntaxField: 'a field of the first record (after filtering and sorting)',
        syntaxCount: 'how many records match',
        syntaxAggregate: 'over every matching record',
        syntaxFormat: 'with a number or date format',
        preview: 'Preview',
        matching: '{n} matching record | {n} matching records',
        previewFailed: 'The preview couldn\'t be loaded.',
        format: 'Format',
        formatAuto: 'Automatic',
        formatNumber: 'Number',
        formatDate: 'Date',
        formatText: 'Text',
        decimals: 'Decimals',
        pattern: 'Pattern',
        chartManual: 'Type in',
        chartFromSource: 'Data source',
        tableBoundNotice: 'This table shows data from a data source. Choose its columns, formats and filters under Data source; change the headings here.',

        editHeadings: 'Edit headings',

        headingsIntro: 'The text at the top of each column. Leave one empty to show the field name.',

        headingsHidden: 'The heading row is turned off under Data source, so headings aren\'t shown on the screen.',

        headingsNoColumns: 'The data source has no data yet. Fetch it first, then come back to name the columns.',
        ops: {
            eq: 'is',
            ne: 'is not',
            gt: 'greater than',
            gte: 'at least',
            lt: 'less than',
            lte: 'at most',
            contains: 'contains',
            empty: 'is empty',
            notEmpty: 'is not empty'
        },
        agg: {
            none: 'The value of a field',
            count: 'Number of records',
            sum: 'Sum',
            avg: 'Average',
            min: 'Lowest',
            max: 'Highest',
            first: 'First',
            last: 'Last',
            eachRecord: 'Each record'
        }
    },
    dataSources: {
        formTitle: 'Filling in this form',
        formIntro: 'Staff fill this form in on the quick edit page, on their phone: signed in with Edit or Quick edit access, or through a share link. Screens update within seconds.',
        formFillIn: 'Fill in now',
        formShareLink: 'Share link (no sign-in needed)',
        formLinkSet: 'A share link exists.',
        formNoLink: 'No share link.',
        formCreateLink: 'Create a share link',
        formNewLink: 'Make a new link',
        formRemoveLink: 'Remove the link',
        formReplaceWarning: 'The current link stops working at once.',
        formLinkHint: 'Anyone with the link can change this form, so share it only with the people who should.',
        formLinkTitle: 'Share link',
        formLinkOnce: 'Copy the link now: it is shown only this once. Anyone who has it can fill in this form.',
        formLinkRemoved: 'The share link no longer works.',
        webhookWizardHint: 'A webhook has nothing to test yet: its data arrives when another system sends it. Save it, then open it to get its address and key.',
        webhookTitle: 'Webhook',
        webhookAddress: 'Send data with a POST to this address',
        webhookKey: 'Key (sent in the X-Webcy-Key header, or as ?key=)',
        webhookKeySet: 'A key is set.',
        webhookNoKey: 'No key yet — data sent here is refused until you generate one.',
        webhookGenerateKey: 'Generate key',
        webhookNewKey: 'Generate a new key',
        webhookReplaceWarning: 'The current key stops working straight away.',
        webhookKeyTitle: 'Your webhook key',
        webhookKeyOnce: 'Copy the key now — it is shown only this once. If it\'s lost, generate a new one.',
        webhookExample: 'For example:',
        stepFinishName: 'Name',
        dataIntroSimple: 'Webcy reads the data and shows what it found.',
        onSaveHint: 'Screens update as soon as you save changes here — there is no schedule.',
        pushHint: 'The data is sent to Webcy by another system — there is nothing to schedule.',
        scheduleOnSave: 'When saved',
        schedulePush: 'When data is sent',
        tableSummary: '{rows} row(s), {columns} column(s)',
        editTable: 'Edit table',
        createTable: 'Create table',
        uploadFile: 'Upload file',
        replaceFile: 'Upload a new version',
        sheet: 'Sheet',
        fileMissing: 'The uploaded file is no longer there. Upload it again.',
        uploadFailed: 'The file couldn\'t be uploaded.',
        selectAccount: 'Select an account to see its data sources.',
        add: 'Add data source',
        fetchNow: 'Fetch now',
        none: 'No data sources yet.',
        addFirst: 'Add one now',
        intro: 'A data source imports data from another system — a REST API to begin with — on a schedule, and stores it in Webcy so it can be shown on screens.',
        colType: 'Type',
        colStatus: 'Status',
        colSchedule: 'Schedule',
        colLastFetched: 'Last fetched',
        colRecords: 'Records',
        failedInARow: 'Failed {n} times in a row',
        status: {
            running: 'Fetching',
            paused: 'Paused',
            never: 'Not fetched yet',
            ok: 'OK',
            failed: 'Failed'
        },
        fetchQueued: 'Fetch started. It can take up to half a minute to begin.',
        deleteConfirm: 'Delete the data source "{name}" and all of its data?',
        scheduleEveryMinute: 'Every minute',
        scheduleEveryNMinutes: 'Every {n} minutes',
        scheduleHourly: 'Every hour',
        scheduleHourlyAt: 'Every hour at :{minute}',
        scheduleDaily: 'Daily at midnight',
        scheduleDailyAt: 'Daily at {time}',
        categories: {
            Request: 'Request',
            Authentication: 'Authentication',
            Response: 'Response',
            Pagination: 'Pagination',
            Settings: 'Settings'
        },
        testSucceeded: 'Found {records} record(s) in {pages} page(s) (HTTP {status}).',
        fieldsFound: 'Fields',
        firstRecords: 'The first {n} record(s)',
        rawResponse: 'Raw response',
        rawResponseHint: 'The first response exactly as the API returned it. Use it to find the records path, e.g. data.items.',
        requestLog: 'Request log',
        addTitle: 'Add data source',
        editTitle: 'Edit data source',
        pickType: 'What kind of data source?',
        noTypes: 'No data source types are available.',
        pickDifferentType: 'Pick a different type',
        schedule: 'Schedule',
        fetch: 'Fetch',
        minutely: 'Every few minutes',
        hourly: 'Hourly',
        daily: 'Daily',
        everyNMinutes: 'Every',
        nMinutes: '{n} minutes',
        atMinute: 'At minute',
        atTime: 'At',
        active: 'Active',
        activeHint: 'A paused data source keeps its data but isn\'t fetched.',
        fetchAfterSaving: 'Fetch as soon as it\'s saved',
        testButton: 'Test & preview',
        testHint: 'Runs the request now without saving anything, and shows what came back.',
        typeUnavailable: 'This data source\'s type is no longer available.',
        secretSaved: 'A value is saved. Type to replace it, or leave it as it is.',
        backToList: 'Back to data sources',
        notFound: 'This data source was not found.',
        lastRunFailed: 'The last fetch failed. The data below is from the last successful fetch.',
        seeRunLog: 'See why',
        tabData: 'Data',
        tabFields: 'Fields',
        tabLastRun: 'Last run',
        tabRaw: 'Raw response',
        noRecords: 'The last fetch returned no records.',
        notFetchedYet: 'Nothing has been fetched yet.',
        fieldsHint: 'The fields found in the records. Nested values are written as paths, e.g. address.city.',
        fieldPath: 'Field',
        fieldType: 'Type',
        neverRun: 'This data source hasn\'t been fetched yet.',
        rawHint: 'The first response of the last successful fetch ({date}), exactly as the API sent it.',
        rawTruncated: 'Only the first 1 MB is kept, so the response is cut off.',
        rawNone: 'No raw response is stored yet. It is kept from the next successful fetch on.',
        copyRaw: 'Copy',
        rawCopied: 'Copied to the clipboard.',
        next: 'Next',
        back: 'Back',
        done: 'Done',
        steps: {
            Table: 'Table',
            File: 'File',
            Request: 'Connection',
            Authentication: 'Authentication'
        },
        stepIntros: {
            Table: 'Type the table in, or paste it from Excel. The first row holds the column names.',
            File: 'Upload the spreadsheet. To update the data later, upload a new version here.',
            Request: 'Where the data comes from.',
            Authentication: 'How Webcy signs in to the API. Leave it at None if the API is public.'
        },
        stepData: 'Data',
        stepFinish: 'Name & schedule',
        headersButton: 'Headers…',
        headersTitle: 'Request headers',
        dataIntro: 'Webcy sends the request and shows what came back. A list in the response becomes one record per item; an object becomes a single record.',
        suggestSingle: 'This came back as a single record. If the list you want is inside it, pick it:',
        suggestFailed: 'These lists were found in the response. Pick the one with your records:',
        wholeResponse: '(the whole response)',
        nRecords: '{n} record | {n} records'
    },
    brandKits: {
        create: '+ Create',
        setAsDefault: 'Set as default',
        loading: 'Loading brand kits ...',
        noKits: "You have no brand kits yet. Create one to define your colors, typography and logos in a single place — they'll then appear in every color and font picker, and changing a value here updates every screen that uses it.",
        colPalette: 'Palette',
        colTypography: 'Typography',
        colLogos: 'Logos',
        default: 'Default',
        none: 'None',
        rolesCount: '{count} role(s)',
        logosCount: '{count} logo(s)',
        deleteTitle: 'Delete brand kit',
        deleteConfirm: 'Delete "{name}"? Widgets referencing its colors will fall back to the last known value stored with each reference, so nothing turns black — but they will no longer update with the brand.',
        createTitle: 'Create a brand kit',
        createManually: 'Create manually',
        createManuallyDesc: 'Start from a blank kit and add your colors, fonts and logos yourself.',
        generateFromWebsite: 'Generate from a website',
        generateFromWebsiteDesc: "Paste a URL and let AI build a starter kit from the site's brand.",
        websiteAddress: 'Website address',
        websiteHint: 'The public homepage works best',
        fetchingBrand: 'Fetching the site and analyzing its brand — this can take up to a minute.',
        back: 'Back',
        analyze: 'Analyze',
        analysisFailed: 'The analysis could not be completed.',
        editTitle: 'Edit brand kit',
        createKitTitle: 'Create brand kit',
        generatedFromPre: 'Generated from',
        generatedFromPost: 'review and adjust everything before saving.',
        nameHint: "e.g. 'Main brand' or a sub-brand / campaign name",
        tabColors: 'Colors',
        tabTypography: 'Typography',
        tabLogos: 'Logos',
        tabGuidelines: 'Guidelines',
        swatch: 'Swatch',
        colKey: 'Key',
        colValue: 'Value',
        noColors: 'No colors yet. Add the ones your brand actually uses — each becomes a swatch in every color picker.',
        addColor: '+ Add color',
        keyWord: 'Key',
        keyExplPre: 'becomes the CSS variable name',
        keyExplPost: "that widgets reference. Renaming a key after it's in use breaks the link — those widgets fall back to the value stored alongside the reference.",
        contrast: 'Contrast',
        contrastDesc: 'WCAG ratios for each pairing. Signage is usually read at a distance, so treat AA as a floor rather than a target.',
        colText: 'Text',
        colOn: 'On',
        colRatio: 'Ratio',
        colGrade: 'Grade',
        colPreview: 'Preview',
        sample: 'Sample',
        colRole: 'Role',
        colFont: 'Font',
        colSize: 'Size',
        colWeight: 'Weight',
        noTypography: 'No typography roles yet. A role like "Heading" or "Body" lets a widget ask for the brand\'s heading font rather than naming a specific family.',
        addRole: '+ Add role',
        fontListNote: "The font list comes from your account's fonts plus the standard web-safe stacks. Upload custom fonts under Content → Fonts.",
        noLogos: 'No logos yet. Add your primary logo plus any variants (inverse for dark backgrounds, an icon-only mark) so screens always use an approved file.',
        uploadLogo: 'Upload logo',
        uploadingLogo: 'Uploading ...',
        guidelinesIntro: 'A read-only summary you can share, plus the raw values for anyone working outside Webcy.',
        palette: 'Palette',
        noColorsDefined: 'No colors defined.',
        typography: 'Typography',
        quickBrownFox: 'The quick brown fox',
        noTypographyDefined: 'No typography roles defined.',
        export: 'Export',
        copyCss: 'Copy CSS',
        downloadJson: 'Download JSON',
        copied: 'Copied',
        logoUploadFailed: 'Logo upload failed.',
        brandKit: 'Brand kit',
        defaultLower: 'default',
        selectorHint: "Leave empty to use the account's default kit. Set it only to override this screen."
    },
    themes: {
        loading: 'Loading themes ...',
        noThemes: 'You have no themes yet!',
        unpublished: 'Unpublished',
        deleteConfirm: 'Are you sure you wish to delete this theme?  You can always retrieve it later from the recycle bin.',
        addTheme: '+ Add theme',
        addThemeTitle: 'Add theme',
        theme: 'Theme',
        loadingTheme: 'Loading theme ...',
        savingTheme: 'Saving theme ...',
        publishingTheme: 'Publishing theme ...'
    },
    devices: {
        nextExecution: 'Next execution in ~{seconds} seconds',
        lastUpdateFinished: 'Last update started at {0} and finished at {1} with message:',
        lastUpdateStarted: 'Last update started at {0}',
        noUpdateHistory: 'No update history found for this device.',
        noVersion: 'No version reported',
        newVersionAvailable: 'New version available!',
        upToDate: 'Up to date',
        versionAvailable: '{version} is available',
        noReleaseNotes: 'No published release notes available for this version.',
        offline: 'Offline',
        offlineFor: '(for {duration})',
        online: 'Online',
        offHours: '(off hours)',
        lastSeenAgo: '(last seen {seconds}s ago)',
        lastSeenAt: 'Last seen at: {time}',
        noHeartbeat: 'Not seen yet',
        preloading: 'Preloading assets ... please wait!',
        workingOnAsset: 'Working on asset {current} of {total} - {progress}%',
        liteTitle: 'Webcy Lite player (browser)',
        disconnected: 'Disconnected',
        liveConnection: 'Live connection',
        hasSchedule: 'This player has a schedule defined',
        editAssociatedScreen: 'Edit associated screen ...',
        editAssociatedPlaylist: 'Edit associated playlist ...',
        clonePlayer: 'Clone player',
        showPlayerUrl: 'Show player URL ...',
        openPlayerUrl: 'Open player URL ...',
        reloadPlayerLive2: 'Reload player now (via live connection)',
        noContentAssigned: 'No content assigned!',
        editPlayerSettings: 'Edit player settings ...',
        playerUrlTitle: 'Player URL',
        playerUrlPrompt: 'Copy/paste this URL to the browser in the player',
        addPlayer: 'Add player',
        tabDisplaySettings: 'Display settings',
        tabMobile: 'Mobile specific',
        contentToShow: 'Content to show',
        offHoursHint: 'Specify a daily time period when this device should show a black screen',
        offHourStarts: 'Off-hour starts',
        offHourStartsHint: 'Select the time of day when the player should start showing a black screen',
        offHourEnds: 'Off-hour ends',
        offHourEndsHint: 'Select the time of day when the player should stop showing a black screen',
        bgColorHint: 'If the screen being displayed is smaller than the device viewport, this color will be shown in the overflow instead of white',
        autoScale: 'Automatically scale the assigned screen to the physical resolution of the connected display',
        zoomFactor: 'Zoom factor for non-mobile devices',
        zoomFactorHint: 'While the Scaling option above will work for mobile devices, it will not work for devices using desktop based browsers.  In that case, use this setting instead to control the scaling of the screen.  If the screen you are showing is full HD but the physical display is 4K, set this to 2.',
        flipX: 'Flip the player output by 180 degrees on the X-axis',
        flipXHint: 'Flip the player output by 180 degrees on the X-axis. Might be helpful if the physical display/screen is mounted upside down or configured incorrectly.',
        flipY: 'Flip the player output by 180 degrees on the Y-axis',
        flipYHint: 'Flip the player output by 180 degrees on the Y-axis.',
        pixelRatioWarning: 'This device has reported a pixel ratio of {ratio} so you should specify a scaling of {scaling}.',
        applyRecommended: 'Apply recommended settings',
        webAppCapable: 'Output web-app-capable meta-tag for mobile devices',
        statusBarStyle: 'Status bar style',
        statusBarStyleHint: 'Changes the status bar color on iOS/mobile devices',
        statusDefault: 'Default',
        statusBlack: 'Black',
        statusBlackTranslucent: 'Black (translucent)',
        autoReload: 'Reload this player every day at a specified time',
        autoReloadHint: 'Might help overcome issues that might build up on the player, such as memory and/or connectivity issues.',
        reloadTimeLabel: 'Time',
        reloadTimeHint: 'Select the time of day when the player should be reloaded',
        enableAssetPreload: 'Enable asset preload',
        enableAssetPreloadHint: 'Most assets (images/videos) used by the player will be preloaded before the actual screens are shown.',
        omitOnlineCheck: 'Omit from online check',
        omitOnlineCheckHint: 'If checked, the online/offline state of this player will not be monitored',
        updatePlayer: 'Update player',
        createPlayer: 'Create player',
        signageTitle: 'Webcy Digital Signage',
        noContentDevice: 'This device, {0}, has no associated content yet!',
        noContentInstructions: 'Log in to your Webcy account, go to the devices list and locate the device called {0}.  Assign a screen or a playlist to it and it will be shown here.',
        screenNotFound: 'This linked screen ({id}) cannot be found!',
        screenNotFoundInstructions: 'Log in to your Webcy account, go to the devices list and locate the device called {0}.  The assigned screen might have been deleted.',
        playlistNotFound: 'This linked playlist ({id}) cannot be found!',
        playlistNotFoundInstructions: 'Log in to your Webcy account, go to the devices list and locate the device called {0}.  The assigned playlist might have been deleted or is not published.'
    },
    players: {
        timeZone: 'Time zone',
        timeZoneOwn: "The player's own: {zone}",
        timeZoneOwnUnknown: "The player's own clock",
        timeOnPlayer: 'Time on the player now: {time} ({zone}, {offset}).',
        timeZoneUnknown: "The player hasn't reported its time zone yet.",
        timesInPlayerZone: ' Off hours, dimming and the daily reload use this time.',
        reportsUtcWarning: 'This player reports UTC, which usually means its clock was never set up. If the screen is in another time zone, choose it here.',
        timeZoneNeedsUpdate: 'This player runs version {version}: off hours and the daily reload follow the time zone from version 1.0.47. Dimming follows it now.',
        reloadTimeZoneHint: "In the player's time zone ({zone}).",
        updateChannel: 'Update channel',
        updateChannelStable: 'Stable (recommended)',
        updateChannelBeta: 'Beta: early versions for testing',
        updateChannelHint: 'Beta players install the newest of the beta and stable versions. Switching back to Stable never downgrades: the player stays on its version until a newer stable one is out.',
        betaChip: 'Beta',
        betaChannelTitle: 'Updates from the beta channel',
        enableDimming: 'Dim screens',
        dimmingHint: 'Content keeps playing under a dark overlay between these times (server time).',
        dimFrom: 'Dim from',
        dimTo: 'Dim to',
        dimBrightness: 'Brightness',
        dimBrightnessHint: 'Screen brightness while dimmed: 100 % = no dimming, 0 % = black.',
        dimmingChipTitle: 'Screens dimmed to {brightness} % from {from} to {to} ({zone})',
        scanQrPlayer: 'Scan the QR code above, or visit {host}/adopt-player and use the code above to pair this player to your account.',
        scanQrDevice: 'Scan the QR code above, or visit {host}/adopt and use the code above to pair this player to your account',
        selectDevice: 'Select device',
        loadingDevices: 'Loading devices ...',
        addLitePlayer: 'Add a lite player',
        liteIntro: 'A lite player runs in any web browser. Register one here with its settings, or just open it in a browser on the display device to pair it.',
        openInBrowser: 'Open player.webcy.com in a browser on the device',
        openInBrowserDesc: 'On the display device, open any browser and go there — or copy this URL and open it on the device.',
        copied: 'Copied!',
        copyUrl: 'Copy URL',
        registerManually: 'Register manually',
        registerManuallyDesc: "Set up a new lite player with a name, group and display settings. Then grab it's URL and open it on your device - or start the adoption process on the device (by opening player.webcy.com) and then adopt it as this new manually created player.",
        editPlayer: 'Edit player',
        tabGeneral: 'General',
        tabAdvanced: 'Advanced',
        tabLocation: 'Location',
        placeInGroup: 'Place player in group',
        enableOffHours: 'Enable off-hours',
        offHoursHint: 'Specify a daily time period when this player should show a black screen on all monitors',
        offHourStarts: 'Off-hour starts (HH:mm)',
        offHourEnds: 'Off-hour ends (HH:mm)',
        autoReload: 'Reload this player every day at a specified time',
        reloadTime: 'Reload time (HH:mm)',
        enableAssetPreload: 'Enable asset preload',
        omitFromOnlineCheck: 'Omit from online check',
        getLocation: 'Get location',
        getLocationConfirm: 'This will attempt to determine the player location based on its last reported IP-address.  Continue?',
        editMonitor: 'Edit monitor',
        tabContent: 'Content',
        tabDisplay: 'Display',
        tabInfo: 'Info',
        noMonitorInfo: 'This player has not reported any hardware detail for this monitor. Monitor information is read from the display itself and is available on Linux players running 1.0.30 or later.',
        infoMonitor: 'Monitor',
        infoConnection: 'Connection',
        infoName: 'Model',
        infoVendor: 'Manufacturer',
        infoProductCode: 'Product code',
        infoSerial: 'Serial number',
        infoManufactured: 'Manufactured',
        infoWeekOf: 'Week {week}, {year}',
        infoNative: 'Native resolution',
        infoPhysicalSize: 'Screen size',
        infoSizeVal: '{w} × {h} cm (about {inches}")',
        infoEdidVersion: 'EDID version',
        infoChecksum: 'EDID checksum',
        infoChecksumOk: 'Valid',
        infoChecksumBad: 'Invalid (common on inexpensive displays; the details above are still usually correct)',
        infoIndex: 'Monitor number',
        infoConnector: 'Connector',
        infoNode: 'Device node',
        infoEnabled: 'Output',
        infoResolution: 'Reported resolution',
        infoIdentityKey: 'Identity',
        infoIdentitySource: 'Identified by',
        infoModes: 'Supported modes ({count})',
        infoRawEdid: 'Raw EDID',
        infoRawEdidHint: 'The unprocessed data block read from the display, base64 encoded. Useful if the details above look wrong.',
        identity_edid_serial: 'Serial number — this exact screen, whichever port it is plugged into',
        identity_edid_serial_text: 'Printed serial — this exact screen, whichever port it is plugged into',
        identity_edid_model: 'Model and port — this screen has no serial number',
        identity_connector: 'Port — whichever screen is plugged into this port is this monitor, so a replacement screen keeps its content',
        identity_index: 'Detection order — no display information available on this platform',
        monitorName: 'Monitor name (optional)',
        screen: 'Screen',
        playlist: 'Playlist',
        screenToShow: 'Screen to show',
        playlistToShow: 'Playlist to show',
        backgroundColor: 'Background color',
        autoScale: 'Automatically scale the assigned content to the physical resolution of the connected display',
        zoomFactor: 'Zoom factor',
        flipX: 'Flip the player output 180° on the X-axis',
        flipY: 'Flip the player output 180° on the Y-axis',
        viewportMetaTag: 'Output a view-port meta tag',
        useDeviceWidth: 'Use device-width',
        useScreenWidth: 'Use the screen width in pixels',
        useSpecifiedWidth: 'Use this specified width',
        scaling: 'Scaling',
        videoWallMenu: 'Video wall ...',
        videoWall: 'Video wall',
        videoWallChip: 'Video wall {cols}×{rows}',
        videoWallTitle: 'Video wall',
        enableVideoWall: 'Enable video wall (span a single piece of content across all monitors)',
        wallColumns: 'Columns',
        wallRows: 'Rows',
        wallContent: 'Wall content',
        wallScreenToShow: 'Screen to show across the wall',
        wallPlaylistToShow: 'Playlist to show across the wall',
        wallLayout: 'Monitor layout',
        wallLayoutHint: 'Assign each physical monitor to a cell of the wall grid.',
        wallCellEmpty: '(empty)',
        wallUnassigned: 'Unassigned monitors',
        wallNoMonitors: 'This player has not reported any monitors yet.',
        wallSizeHint: 'Design your wall content at {width}×{height} px to fill the whole wall.',
        wallNoContent: 'Not set',
        wallScheduled: 'Scheduled',
        wallAlwaysOn: 'Always on',
        wallScheduleColon: 'Schedule:',
        wallBaseContent: 'Base content (shown when no schedule is active)',
        wallScheduleLabel: 'Show the wall on this schedule',
        wallHowItWorks: 'With a schedule, the wall shows the screen assigned to the schedule’s active window — use wall-sized screens. The content below is the fallback shown when no window is active.',
        wallScheduleContentHint: 'During its active windows the wall shows that window’s assigned screen or playlist.',
        wallIdleContent: 'Idle / fallback wall content',
        wallIdleContentHint: 'Shown when no schedule window is active. Leave empty to return to each monitor’s own content while idle.',
        wallWhenIdleColon: 'When idle:',
        wallIdlePerMonitor: 'each monitor’s own content',
        wallFit: 'Content fit',
        wallFitHint: 'How content that doesn’t match the wall’s shape is fitted',
        wallFitCover: 'Fill (crop)',
        wallFitContain: 'Fit (bars)',
        wallFitStretch: 'Stretch',
        wallBezel: 'Bezel (px)',
        wallBezelHint: 'Gap between monitors the image flows behind',
        wallBarColor: 'Bar colour',
        wallSync: 'Synchronise tiles',
        wallSyncHint: 'Every tile changes item at the same moment, and videos start aligned. Videos are not frame-locked, so very long loops can drift slightly.',
        wallModeAlways: 'Always active',
        wallModeSchedule: 'Activate on a schedule',
        wallPreviewLoading: 'Loading preview…',
        wallPreviewScheduled: 'The schedule supplies the content, so there is nothing to preview here.',
        wallPreviewNoContent: 'Choose a screen or playlist to preview the wall.',
        wallPreview: 'Preview',
        wallClickToAssign: 'Click a cell to place a monitor, or drag one from the list above',
        wallTray: 'Monitors',
        wallAssigned: 'assigned',
        wallReset: 'Clear',
        invalidPin: 'This pin code is not valid!',
        pinLabel: 'Player pin-code',
        pinHint: 'Enter the 6 character pin code as shown on your player screen',
        adoptingTo: 'You are adopting "{model}" to your Webcy account',
        adoptNew: 'Adopt as a new player and add it to your account',
        adoptLink: 'Adopt and link to an existing player in your account - use this option if you are replacing one player with another for example',
        selectAccountLink: 'Select the account you wish to link this player to',
        atLimit: 'You\'re at your plan\'s player limit. Choose "Adopt and link to an existing player" above to replace one, or upgrade your plan to add more.',
        playerName: 'Player name',
        playerNameHint: 'Give this player a descriptive name',
        playerDescription: 'Player description',
        playerDescriptionHint: 'Describe this player',
        loadingPlayers: 'Loading players ...',
        searchPlaceholder: 'Filter by name ...',
        noMatches: 'No players match your filter.',
        yourPlayers: 'Your players',
        noExistingPlayers: 'Your account has no existing players. The adopted player will be added as a new player.',
        adoptPlayer: 'Adopt player',
        playerAdopted: 'Player adopted',
        adoptionSuccess: 'Player adoption successful.',
        nativeTitle: 'Webcy player (native)',
        editPlayerMenu: 'Edit player ...',
        reloadPlayerLive: 'Reload player now (live)',
        remoteManagementMenu: 'Remote management ...',
        deletePlayerMenu: 'Delete player ...',
        playerColon: 'Player:',
        unknown: 'Unknown',
        updateAvailable: 'Update available',
        updateClickTitle: 'Click to update to v.{version}',
        updateOfflineTitle: 'A newer version (v.{version}) is available; the player is offline',
        updateDownloading: 'Updating — downloading…',
        updateInstalling: 'Installing update, relaunching…',
        updateUpToDate: 'Up to date.',
        updateFailed: 'Update failed.',
        noMonitors: 'No monitors reported yet. Once the player sends a heartbeat its monitors will appear here.',
        monitorsCount: '{count} monitor(s)',
        live: 'Live',
        notLive: 'Not live',
        liveConnTitle: 'Live websocket connection',
        noLiveConnTitle: 'No live websocket connection',
        relaunchWindow: 'Relaunch window',
        editMonitorTitle: 'Edit monitor',
        openMonitorUrl: 'Open monitor URL',
        playlistAssigned: 'Playlist assigned',
        screenAssigned: 'Screen assigned',
        scheduledSuffix: ' (scheduled)',
        noContentAssigned: 'No content assigned',
        monitorN: 'Monitor {index}',
        playerOffline: 'Player offline',
        noLiveWindow: 'No live browser window for this monitor',
        browserWindowActive: 'Browser window active',
        adoptPlayerBtn: '+ Adopt player',
        addLitePlayerBtn: '+ Add lite player',
        addGroupBtn: '+ Add group',
        viewPhysical: 'View as physical players',
        viewMonitors: 'View as individual physical monitors',
        viewList: 'List view',
        viewMap: 'Map view',
        queueCommandBtn: 'Queue command',
        queueCommandTitle: 'Queue command to all',
        queueReload: 'Reload',
        queueReloadNoCache: 'Reload (no cache)',
        queueCommandConfirm: 'Queue "{command}" to all {count} devices/players?',
        queueCommandDoneTitle: 'Command queued',
        queueCommandDone: 'Queued to {count} devices/players.',
        noContentMonitor: 'This monitor (monitor nr {0}) on {1} has no content assigned!',
        noContentMonitorInstructions: 'Log in to your Webcy account, go to the players section, locate the player called {0} and assign some content to monitor nr {1}.',
        noPlayersYet: 'You have no registered players yet! Adopt a Webcy player or add a lite (browser) player to get started.',
        ungrouped: 'Ungrouped players',
        noPlayersInGroup: 'There are no players in this group right now.  Edit a player and place it in this group.',
        noMonitorsInGroup: 'There are no monitors in this group right now.',
        colPlayer: 'Player',
        colResolution: 'Resolution',
        colGroup: 'Group',
        colStatus: 'Status',
        colLocation: 'Location',
        viewOnMap: 'View on map',
        locationNotSet: 'Location not set',
        notConnected: 'Not connected',
        litePlayer: 'Lite player',
        noLocations: 'No players have a location set yet!  Edit a player and set its location in the Location tab.',
        showDetails: 'Show player details',
        collapse: 'Collapse',
        addGroupTitle: 'Add player group',
        deleteGroupConfirm: 'Are you sure you wish to delete this player group? Any players in the group will be preserved and moved to ungrouped players.  You can always retrieve the group later from the recycle bin.',
        renameGroupTitle: 'Rename player group',
        deletePlayerTitle: 'Are you sure you wish to delete this player?',
        deletePlayerConfirm: 'To confirm, please type in the player name',
        deleteCancelled: 'Delete cancelled',
        deleteIncorrectName: 'Incorrect player name entered, nothing deleted!',
        updatePlayerTitle: 'Update player',
        updatePlayerConfirm: 'Update "{name}" to the latest version now? The player restarts when the update completes.',
        machineConflictChip: '{count} machines',
        machineConflictTitle: '{count} separate machines are paired as this one player (likely a cloned install). Open remote management to split them.'
    },
    remote: {
        title: 'Remote management - {name}',
        tabInfo: 'General',
        tabMonitors: 'Monitors',
        tabScreenshots: 'Screenshots',
        tabLogs: 'Player logs',
        tabCache: 'Asset cache',
        rowPlayer: 'Player',
        rowVersion: 'Version',
        rowServiceMode: 'Service mode',
        serviceModeOn: 'On (updates install without relaunching)',
        serviceModeOff: 'Off',
        rowOs: 'Operating system',
        rowArchitecture: 'Architecture',
        rowProcessor: 'Processor',
        rowRendering: 'Rendering',
        renderingHardware: 'GPU (hardware)',
        renderingSoftware: 'CPU (software)',
        videoOnGpu: 'Video decoding on GPU',
        videoOnCpu: 'Video decoding on CPU',
        noVaapiDriver: 'no VA-API driver installed',
        gpuCrashes: 'GPU process crashed {n}×',
        rowMonitors: 'Monitors',
        rowMemory: 'Memory usage',
        rowFreeDisk: 'Free disk space',
        rowAssetCache: 'Asset cache',
        rowCpuTemp: 'CPU temp',
        rowCpuLoad: 'CPU load',
        rowAppMemory: 'App memory',
        rowUptime: 'Uptime',
        rowNetwork: 'Network',
        rowPower: 'Power/thermal',
        rowDateTime: 'Player date/time',
        rowTimezone: 'Player timezone',
        rowIp: 'Player IP-address',
        archMismatch: 'This player is running an {app} build on {os} machine. Install the matching build.',
        archBuildOn: '{app} build on {os}',
        memoryUsed: '{used} of {total} GB used',
        freeDisk: '{percent}% ({mb}MB)',
        assetCacheVal: '{mb}MB ({items} items)',
        uptimeVal: 'App {app} · OS {os}',
        colMonitor: 'Monitor',
        colModel: 'Model',
        colResolution: 'Resolution',
        colContent: 'Content',
        colStatus: 'Status',
        relaunch: 'Relaunch',
        placement: 'Placement',
        moveToDisplay: 'Move to display',
        displayN: 'Display {n}',
        primary: 'primary',
        colDisplay: 'Display',
        colPosition: 'Position',
        colWindows: 'Monitor windows',
        windowsStacked: 'More than one monitor window is on the same display. Use Placement → Move to display on a monitor to move its window to the right screen.',
        noUrlReported: 'No URL reported',
        monitorN: 'Monitor {index}',
        viewFullSize: 'View full-size',
        taken: 'Taken: {date}',
        requestNew: 'Request new',
        noScreenshots: 'No screenshots exist!',
        requestScreenshots: 'Request screenshots',
        requestLogs: 'Request logs',
        received: 'Received: {date}',
        noLogFile: 'No log file has been requested!',
        colFile: 'File',
        colSize: 'Size',
        colCached: 'Cached',
        removeFromCache: 'Remove from cache',
        cacheEmpty: 'The asset cache is empty.',
        refreshFromPlayer: 'Refresh from player',
        noCacheListing: 'No cache listing has been requested from this player yet.',
        requestCacheContents: 'Request cache contents',
        commands: 'Commands',
        queueCommand: 'Queue command',
        unpair: 'Unpair',
        restartLive: 'Restart (via live connection)',
        pendingCommands: 'Pending commands',
        pendingSubtitle: 'Pending commands can take up to 60 seconds to be processed.',
        offlineNoCommands: 'Player is offline and cannot accept commands!',
        noPending: 'No pending commands',
        issued: 'Issued: {date}',
        messageLabel: 'Message to show on every monitor',
        content_playlist: 'Playlist',
        content_screen: 'Screen',
        content_none: 'No content',
        wifi: 'Wi-Fi',
        wired: 'Wired',
        notAvailable: 'Not available',
        underVoltage: 'Under-voltage',
        throttled: 'Throttled',
        freqCapped: 'Freq capped',
        softTempLimit: 'Soft temp limit',
        pastUnderVoltage: 'under-voltage',
        pastThrottling: 'throttling',
        pastTempLimit: 'temp limit',
        okPast: 'OK (past: {issues})',
        ok: 'OK',
        noWindow: 'No window',
        networkErrorPage: 'Network error page',
        offHours: 'Off-hours',
        loadFailed: 'Load failed',
        showingContent: 'Showing content',
        cmdReloadNoCache: 'Reload (no cache)',
        cmdScreenshot: 'Request screenshots',
        cmdRequestLogs: 'Request logs',
        cmdUnpair: 'Unpair',
        cmdClearCache: 'Clear asset cache',
        cmdRestart: 'Reboot device',
        cmdIdentify: 'Identify monitors',
        cmdMute: 'Mute audio',
        cmdUnmute: 'Unmute audio',
        cmdRestartApp: 'Restart app',
        cmdRequestCacheContents: 'Request cache contents',
        cmdRemoveCachedItem: 'Remove cached item',
        cmdExitFullScreen: 'Exit full screen',
        cmdEnterFullScreen: 'Enter full screen',
        emergencyMessage: 'Emergency message',
        playerOffline: 'Player offline!',
        playerOfflineMsg: 'This player seems to be offline - you can only queue commands to online players.',
        confirmExit: 'Are you sure you wish to perform the Exit command? The player will have to be physically restarted.',
        confirmRestartApp: 'Restart the player application? Content will briefly disappear while it relaunches.',
        confirmRestart: 'Reboot the player device now?',
        confirmDisplayOff: 'Turn the connected display(s) off? Use "Display on" to turn them back on.',
        confirmUnpair: 'Are you sure you wish to unpair this player? Pairing it again requires physical access to the player.',
        confirmRestartLive: 'This will attempt to restart the player via the live connection. Continue?',
        removeCacheConfirm: 'Remove "{name}" from the player\'s asset cache? It will be re-downloaded the next time it is shown.',
        updDownloading: 'Updating player — downloading new version…',
        updInstalling: 'Update downloaded — installing and relaunching…',
        updUpToDate: 'Player is up to date.',
        updFailed: 'Update failed — check the player logs.',
        rowPhysicalResolution: 'Physical resolution',
        rowAssignedDims: 'Assigned screen dimensions:',
        rowPixelRatio: 'Pixel ratio',
        rowDisplayNum: 'Display #',
        requestScreenshotSingle: 'Request screenshot!',
        confirmExitDevice: 'Are you sure you wish to perform the Exit command?  The player will have to be physically restarted in order to restart the Webcy player!',
        confirmUnpairDevice: 'Are you sure you wish to unpair this player from your account? Pairing it again to your account requires physical access to the player.',
        confirmRestartDevice: 'This will attempt to restart the player via the live connection.  This only works for players running the native Webcy app and the player must have an active live connection to the Webcy servers.  Continue?',
        machineConflictInfo: '{count} separate physical machines are heartbeating as this one player — most likely a cloned/duplicate install sharing its id. Split a machine off to give it its own player you can control independently.',
        machinesSingle: 'The physical machine currently paired as this player:',
        colMachineHost: 'Machine',
        colMachineLastSeen: 'Last seen',
        secondsAgo: '{seconds}s ago',
        splitMachine: 'Split into its own player',
        splitConfirm: 'Split "{host}" off into its own new player? It will adopt the new player on its next heartbeat (within a minute); the other machine keeps this player. This creates a new (billable) player.',
        splitDoneTitle: 'Machine split off',
        splitDoneMsg: 'A new player was created. The machine will move to it on its next heartbeat (usually within a minute), after which you can control each machine independently.'
    },
    playlists: {
        transition: 'Transition',
        transitionIntro: 'Choose the effect used when the player switches from this item to the next one.',
        transitionHint: 'How this item disappears and the next one appears',
        addPlaylistBtn: '+ Add playlist',
        playlistsRoot: 'Playlists',
        deleteFolderMsg: 'Delete "{name}"? Its playlists and sub-folders will be moved up to the parent folder.',
        addPlaylist: 'Add playlist',
        title: 'Title',
        loadingScreen: 'Loading screen ...',
        searchPlaceholder: 'Search for playlists by name ...',
        loadingPlaylists: 'Loading playlists ...',
        noPlaylists: 'You have not created any playlists yet!',
        itemCount: '{count} item | {count} items',
        deleteConfirm: 'Are you sure you wish to delete this playlist?  You can always retrieve it later from the recycle bin.',
        addItem: 'Add item',
        itemSettings: 'Item settings',
        contentType: 'Content type',
        image: 'Image',
        video: 'Video',
        dynamic: 'Dynamic',
        dynamicContent: 'Dynamic content',
        dynamicHint: 'The dynamic content shown for this playlist item',
        scaling: 'Scaling',
        contain: 'Contain',
        cover: 'Cover',
        imageLower: 'image',
        videoLower: 'video',
        containDesc: 'shows the whole {media} and may add bars on a differently shaped display.',
        coverDesc: 'fills the display and may crop the edges.',
        duration: 'Duration',
        maxDurationFallback: 'Maximum duration (fallback)',
        seconds: 'seconds',
        forVideoDuration: 'For the duration of the video',
        forVideoDurationHint: 'Show this item for the full length of the video and advance when it finishes. The duration above acts as a safety cap if playback never ends.',
        transitionToNext: 'Transition to next item',
        removeItem: 'Remove item',
        timelineCaption: 'Single item — shown indefinitely. Add another item to enable durations and transitions.',
        videoLength: 'video length',
        transitionMarkerTitle: 'Transition to the next item — click to edit',
        none: 'none',
        loadingPlaylist: 'Loading playlist ...',
        alsoEditingPre: 'This playlist is also being edited by',
        alsoEditingPost: "You'll see their changes as they save — edits made at the same time can overwrite each other.",
        backToPlaylists: 'Back to playlists',
        playlistSettings: 'Playlist settings',
        previewOnPlayer: 'Preview on player',
        togglePreviewOrientation: 'Toggle portrait / landscape',
        previewLandscape: 'Landscape',
        previewPortrait: 'Portrait',
        editContent: 'Edit content',
        containHint: 'Contain — show the whole image/video (may add bars)',
        coverHint: 'Cover — fill the display (may crop the edges)',
        dropToReplace: "Drop to replace this item's content",
        dragVisibleArea: 'Drag to choose the visible area',
        noContentChosen: 'No content has been chosen for this item yet. Open it in the timeline to pick content.',
        playlistEmpty: 'This playlist is empty. Use the “+ Add item” button in the timeline below to get started.',
        selectItemToPreview: 'Select an item in the timeline below to preview it.',
        dropFilesToAdd: 'Drop file(s) to add as new item(s)',
        showProgressIndicator: 'Show a progress indicator on the player',
        showProgressHint: 'Displays a small progress bar and an item counter (e.g. 1/3) so viewers can see how long until the next item is shown.',
        portrait: 'Playlist is in portrait mode',
        portraitHint: 'For monitors mounted sideways. Items are shown 9:16 here and the player rotates the playlist 90 degrees. Takes effect on players when the playlist is published.',
        clockwise: 'Playlist is rotated clock-wise',
        someone: 'Someone',
        newItem: 'New item',
        uploadingFile: 'Uploading {name} ...',
        savingPlaylist: 'Saving playlist ...',
        publishingPlaylist: 'Publishing playlist ...',
        schedulingPublish: 'Scheduling publish ...',
        unsupportedFileType: 'Unsupported file type: {name}',
        changedElsewhere: 'This playlist was changed elsewhere. Save your changes or reload the page to see the latest.',
        playlistUpdated: 'Playlist updated ...'
    },
    weekdays: {
        sunday: 'Sunday', monday: 'Monday', tuesday: 'Tuesday', wednesday: 'Wednesday',
        thursday: 'Thursday', friday: 'Friday', saturday: 'Saturday',
        sunShort: 'Sun', monShort: 'Mon', tueShort: 'Tue', wedShort: 'Wed',
        thuShort: 'Thu', friShort: 'Fri', satShort: 'Sat'
    },
    triggers: {
        loading: 'Loading triggers ...',
        addTrigger: '+ Add trigger',
        noneLong: 'You have no triggers yet! Triggers can be used by external systems and/or players to trigger screen changes in Webcy.  You could for example set up a motion detector so that when motion is detected in front of a certain player, another screen will be displayed.',
        info: 'Triggers can be used by external systems and/or players, such as motion detectors, to trigger screen changes in Webcy.',
        infoAlert: 'Triggers allow other devices, such as motion sensors, to trigger content changes on your devices, like showing a different screen when a person walks by or stands in front of a monitor.',
        noneShort: 'You have no triggers yet!',
        showStats: 'Show stats ...',
        showTriggerUrl: 'Show trigger URL ...',
        activePrefix: 'Active -',
        inactivePrefix: 'Inactive -',
        linkedDevices: 'linked devices',
        incompleteConfig: 'Incomplete configuration - make sure you have linked at least one device and that all linked devices have at least one assigned screen to show',
        deleteConfirm: 'Are you sure you wish to delete this trigger?  You can always retrieve it later from the recycle bin.',
        triggerUrlTitle: 'Trigger URL',
        triggerUrlHint: 'Perform a GET request to this URL to trigger this trigger',
        editTrigger: 'Edit trigger',
        addTriggerTitle: 'Add trigger',
        isActive: 'Trigger is active',
        linkedDevicesHeader: 'Linked devices',
        noDevicesLinked: 'No devices linked yet!  Click the "+ Link device" button below to link a device to this trigger.',
        linkDevice: '+ Link device',
        toggleDeviceActive: 'Toggle whether triggering this device is active or not',
        noTriggeredScreens: 'No triggered screens have been linked to this device yet!',
        linkScreen: '+ Link screen',
        toggleScreenActive: 'Toggle whether this screen should be shown or not',
        configure: 'Configure ...',
        updateTrigger: 'Update trigger',
        createTrigger: 'Create trigger',
        unlinkDeviceConfirm: 'Are you sure you wish to unlink this device from the trigger?  You can also unlink it temporarily by toggling the switch next to the device name.',
        unlinkScreenConfirm: 'Are you sure you wish to unlink this screen from from the trigger?  You can also unlink it temporarily by toggling the switch next to the screen name.',
        editTriggeredScreen: 'Edit triggered screen',
        addTriggeredScreen: 'Add triggered screen',
        durationMinutes: 'Duration in minutes',
        onlyCertainDates: 'Only at certain dates/times',
        hits: 'hits',
        liveStats: 'Live stats',
        hitsByDateTime: 'Hits by date/time',
        latestHits: 'Latest hits',
        chartHitsSeries: 'Hits'
    },
    schedules: {
        useSchedule: 'Use schedule',
        addScheduledContent: 'Add scheduled content',
        editScheduledContent: 'Edit scheduled content',
        onDayCopyTo: 'On {0} — also copy to:',
        activeOn: 'Active on: {list}',
        notActiveAny: 'Not active on any device or player',
        untitled: 'Untitled',
        addSchedule: '+ Add schedule',
        info: 'Schedules are used to schedule content on devices.  As an example, you could schedule a lunch offer screen to be displayed at 11:45 to 13:30 every weekday.',
        loading: 'Loading schedules ...',
        noSchedules: 'You have no schedules yet!',
        header: 'Schedules',
        inactive: 'Inactive',
        notLinked: 'This schedule is currently not linked to any device or player',
        utilizedOn: 'This schedule is currently utilized on: {list}',
        deleteConfirm: 'Are you sure you wish to delete this schedule?  You can always retrieve it later from the recycle bin.',
        editSchedule: 'Edit schedule',
        addScheduleTitle: 'Add schedule',
        weeklySchedule: 'Weekly schedule',
        transition: 'Transition',
        transitionHint: 'Used when switching to/from this schedule’s content (when full page reload on schedule is off).',
        dateSpecificItems: 'Date-specific items',
        addDateBasedItem: 'Add date-based item',
        noDateSpecific: 'No date-specific items. Use the calendar above for recurring weekly schedules.',
        updateSchedule: 'Update schedule',
        createSchedule: 'Create schedule',
        removeScheduledItemConfirm: 'Are you sure you wish to remove this scheduled item?',
        dynamicContentToShow: 'Dynamic content to show',
        dynamicContentBtn: 'Dynamic content',
        playlistBtn: 'Playlist',
        playlistToShow: 'Playlist to show',
        whenToShow: 'When to show',
        whenToStop: 'When to stop showing',
        exactDate: 'Exact date',
        startDateHint: 'If a date is selected, the screen will only be shown on that exact date at the time selected or at midnight if no time is selected',
        endDateHint: 'If a date is selected, the screen will be shown until that exact date',
        time: 'Time',
        startTimeHint: 'Select the time when the screen will be shown.',
        endTimeHint: 'Select the time when the screen will stop showing',
        weekdaysTitle: 'Weekdays',
        dragHint: 'Drag to add · drag to move · drag the bottom edge to resize · click to edit',
        newBlock: 'New block',
        screenLabel: 'Screen'
    }
}
